import React from 'react';

import ReactDOM from 'react-dom';
import { Button ,Drawer} from '@jd/find-react';

import {
	MessageBox,
	Message
} from 'element-react';
 

import KeeVue from '../base/KeeVue.js'

import FsJsonConfig from './FsJsonConfig.js'



import $ from 'jquery';

import FeasPage from '../render/FeasPage.js'
import FsView from  '../render/FsView.js';

//import html2canvas from 'html2canvas';



export default class FsBuildCenter extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				randId: this.getRandString(),
				activeComponent: {
					style: {
					}
				},
				vueSource: "",
				query: {
					"search_ORMAP_name,title": '',
				},
				vueSource: '',
				currentComponent: null, // 添加时选择的组件
				activeComponentJson: '',
				showActiveRedBorder: false,
				activeDivStyle: {
					left: 0,
					top: 0,
					bottom: null,
					right: null,
					width: 100,
					height: 100,
					background: "",
				},
				jdccScaleDiv: {
				},
				currentScale: 100,
				designerContentStyle: {
					position: "relative",
					top: 10 + "px",
					left: 10 + "px",
					bottom: 10 + "px",
					right: 10 + "px",
					height: '',
					width: null,
					marginTop: null,
					marginLeft: null,
					marginRight: null,
					marginBottom: "300px",
					'transform': 'scale(1)',
					transformOrigin: '0px 0px',
					'WebkitTransform': 'scale(1)',
					'WebkitTransformOrigin': '0px 0px'
				},
				
				 
				templateDialogVisible: false,
				moveComponent: null,
				startPoint: {
					x: 0,
					y: 0,
				},
				currentY: 100,
				fsBoxStartStyle: {
					left: '',
					top: '',
					right: '',
					bottom: '',
				},
				styleX: {
					'transform': 'translateX(' + 0 + 'px)',
					'WebkitTransform': 'translateX(' + 0 + 'px)'
				},
				styleY: {
					'transform': 'translateY(' + 0 + 'px)',
					'WebkitTransform': 'translateY(' + 0 + 'px)'
				},
				tuCengComponent: null,
				isCtrlKey: false,
				selectComponentItems: [],
				selectPoints: [],
				selectStartPoint: {
					left: 0,
					top: 0,
					x0: 0,
					y0: 0
				},
				selectDivStyle: {
					left: "0px",
					top: "0px",
					width: "0px",
					height: "0px",
				},
				isShowSelectDiv: false,
				isMoving: false,
				aceCodeMethodKeyword:{
				},
				templateKeeVue:null,
				isKeeShowBorder: false,
				isMouseOver:false,
				lastTid:null,
				showJsonRight:false,
				isReport:(window.isReport ),
				
				
			};

}

	componentDidMount(){
			 $("#feasReactApp").on("mousedown", this.onMousedown);
			this.clipper= {
				type: '',
				content: null,
			};
			
			// <feas-page ref="designPager" :components="components" :kee-page="keePage" :active-component="activeComponent" :query="query" :debug="true" @command="onCommand"></feas-page>

 
			if(!window.isReport)
			{
				this.vueApp = new window.KeeVue({
					el: '#designContentDivVue',
					data: {
						 components:this.props.components,
						 keePage:this.props.keePage,
						 activeComponent:this.state.activeComponent,
				
					},
					components: {},
					mounted: ()=> {
						// alert("vue mounted"+this.components.length)
						
						//这个是socket多人同步时发送的事件
						
						this.onEvent("changedComponents",()=>{
							console.log("get inited changedComponents event");
							
							// 如果开启了socket才开始传输，否则会导致后端接口报错
							
							if(!window.ServerConfig||!window.ServerConfig.websocketUrl||!window.appId)
							{
								 return ;
							}
							
							
							let pageInitInfo = {
								appId:window.appId,
								fromEditor:window.editorInfo,
								keePage:this.props.keePage 
							}
							// 需要排除isSelect等属性
							
							let pageInitJson = JSON.stringify(pageInitInfo)
							
							let pageDto = JSON.parse(pageInitJson);
							 
							console.log("editPageJson");
							
							// 需要把不需要提交的属性去掉 
							this.removeNotUserProperty(pageDto.keePage.components ); 
							pageInitJson = JSON.stringify(pageDto); 
							
							
							if(pageInitJson!=this.pageInitJson)
							{
								console.log("editPageJson:"+pageInitJson);
								console.log("editPageJson:"+this.pageInitJson);
								
								
								this.pageInitJson = pageInitJson;
								this.doRequest("/keePage/editPageJson",(ret)=>{
									console.log("editPageJson:"+ret);
								},{
									appId:window.appId,
									pageId:this.props.keePage.id,
									pageJson:JSON.stringify(pageInitInfo)
								})
							} 
							// 如果不相等才发送，如果相等，则无需发送 
						});
					},
					render: function(createElement) {
						 
				 
						return createElement('feas-page', {
							attrs: {
								"tag": "fscomponents",
								"components":this.components,
								"kee-page":this.keePage,
								"huabu":true,
								"active-component":this.activeComponent,
								"debug":true
							},
							'style':{
								'padding':'0'
							},
							'class': {
								'kee-full-div':true 
							},
							on: {
								inited: this.inited, 
							}
						}, '');
					},
				methods:{
					showPage:function(components,keePage,activeComponent){
						 
						this.components = components;
						this.keePage = keePage;
						this.activeComponent = activeComponent;
						
						// 页面变更，会触发watch事件，然后重新初始化components，触发inited事件
					},
					inited:function(){ }
				}});
				 
			}
			
			
			
			
			
			
			
			this.onEvent("mousemove", this.onMouseMove);
			 
						
			this.onEvent("changeShowBorder",(isShow)=>{
						   this.state.isKeeShowBorder = isShow;
						   this.refresh();
			});
						
			this.onEvent("drag", this.onDrag);
			this.onEvent("draging", this.onDraging);
			this.onEvent("droped", this.onDroped);
			this.onEvent("selectComponent", this.setActiveComponent);
			this.onEvent("clearSelectState", this.setActiveComponent);
			this.onEvent("changePageType", this.pageFieldChange);
			
			this.onEvent("refreshComponents", ()=>{this.refresh()});
			
			this.onEvent("copyComponent", this.copyComponent);
			this.onEvent("cutComponent", this.cutComponent);
			this.onEvent("pasteComponent", this.pasteComponent);
			this.onEvent("deleteComponent",this.deleteComponent);
			
			this.onEvent("zoomIn", this.zoomIn);
			this.onEvent("zoomOut", this.zoomOut);
			this.onEvent("key.d", this.deleteComponent);
			this.onEvent("box.resize", this.onBoxResize);
			this.onEvent("top.componentSource", this.onTopComponentSource)
			this.onEvent("showComponentJsonPage",this.showComponentJsonPage);
			
			this.onEvent("showVueSource",this.showVueSource);
			this.onEvent("showReact",this.showReact);
			this.onEvent("leftTreeDrop",this.onLeftTreeDrop);
			
			this.onEvent("changePosition",this.onChangePosition);
			
			this.onEvent("checkAliasOlny",this.checkAliasOlny);
			
			
			this.onEvent("addItem",this.onAddItem);
			
			this.onEvent("sucaiManage",this.changeBackground);
			
			this.onEvent("outResFileClick",this.onOutResFileClick);
			 
			
			// setTimeout(()=>{
				
			// },1500);
			this.initEditor();
			
			 
			let that = this;
			$("body").on("mouseup", this.onBodyMouseUp);
			$("body").on('mousewheel', function(event, delta) {
				
				if(!window.isReport)
				{
					//console.log("delta:",event.originalEvent.deltaY);
					if(event.ctrlKey === true) {
						if(event.originalEvent.deltaY > 0) {
							that.zoomIn();
						} else {
							that.zoomOut();
						}
					} else {
						 
					}
				}
				
			});
			this.state.tuCengComponent = {
				id: "tucengdropdown",
				name: 'fs-dropdown',
				cp: {
					title: "图层",
					size: 'mini',
					items: [{
						code: 'top',
						title: '置顶'
					}, {
						code: 'up',
						title: '上移一层'
					}, {
						code: 'down',
						title: '下移一层'
					}, {
						code: 'bottom',
						title: '置底'
					}],
					width: "120px",
					height: "150px"
				}
			}
		}

 

			onChangePosition=(value)=>{
				//alert("shoudao:"+value);
				
				if(this.state.activeComponent)
				{
					let c = this.state.activeComponent;
					this.setVueAttr(c.style, "left", "0px");
					this.setVueAttr(c.style, "top", "0px");
					this.setVueAttr(c.style, "right", "0px");
					this.setVueAttr(c.style, "bottom", "0px");
					this.setVueAttr(c.style, "width", "300px");
					this.setVueAttr(c.style, "height", "200px");
					//this.setVueAttr(c.style, "position", "absolute");
					this.setVueAttr(c.style, "overflow", "visiable");
					let maxZindex = this.getMaxZindex(this.props.components);
					this.setVueAttr(c.style, "zIndex", maxZindex);
				} 
			}
			
		
			
			
			countAliasExists=(componentArray, aliasName)=> {
				let count = 0;
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(c.alias === aliasName) {
							count++;
						}
						if(c.child ) {
							count+= this.countAliasExists(c.child, aliasName); 
						}
					}
					 
				}
				return count;
			}
			
			// 要排除自己的值
			
			checkAliasOlny=(value,callback)=>{
				let newAlias = value;
				
				if(!newAlias)
				{
					// 不能为空
					callback(this.getRandString());
					return
				} 
				for(let i = 1; i < 1000; i++) {
					 
					newAlias = newAlias.replace(/-/g,''); // 去掉-
					
					if(this.countAliasExists(this.props.components, newAlias)<2) {
						
						if(i>1)
						{
							this.showMessage("组件标识重复，自动设置为新值："+newAlias);
						}
						callback(newAlias);
						break;
					}
					else
					{
						newAlias = newAlias.replace("fs-", "").replace("el-", "").replace("feas-", "").replace("kee-", "") +i;
					}
					
					
					
				}
			}
			getMaxZindex=(fromComponents)=>{
				let max = 1;
				for(let i = 0; i < fromComponents.length; i++) {
					let c = fromComponents[i];
					if(c.style.position === "absolute") {
						if(parseInt(c.style.zIndex) > max) {
							max = parseInt(c.style.zIndex)
						}
					}
					if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
						let childMax = this.getMaxZindex(c.child);
						if(childMax > max) {
							max = childMax;
						}
					}
				}
				return max + 1;
			}
			resortZindex=(componentArray, sortArray)=> {
				for(let i = 0; i < componentArray.length; i++) {
					if(componentArray[i].style.position === "absolute") {
						if(sortArray.length === 0) {
							sortArray.push(componentArray[i]);
						} else {
							let isAdded = false;
							for(let n = 0; n < sortArray.length; n++) {
								if(componentArray[i].style.zIndex < sortArray[n].style.zIndex) {
									sortArray.insert(n, componentArray[i]);
									isAdded = true;
									break;
								}
							}
							if(!isAdded) {
								sortArray.push(componentArray[i]);
							}
						}
					}
					this.resortZindex(componentArray[i].child, sortArray);
				}
			}
			selectTuceng=(code, item)=> {
				if(this.state.activeComponent  && this.state.activeComponent.name ) {
					let style = this.state.activeComponent.style;
					let zIndex = style.zIndex;
					if(zIndex === null) {
						zIndex = 0;
					}
					let sortArray = [];
					this.resortZindex(this.props.components, sortArray);
					for(let i = 0; i < sortArray.length; i++) {
						sortArray[i].style.zIndex = i + 1;
					}
					if(code === "up") {
						zIndex++;
						this.setVueAttr(style, "zIndex", zIndex);
						if(style.position !== 'absolute') {
							this.setVueAttr(style, "position", "absolute");
						}
						for(let i = 0; i < sortArray.length; i++) {
							if(sortArray[i].id === this.state.activeComponent.id) {
								if(i < sortArray.length - 1) {
									sortArray[i].style.zIndex = sortArray[i].style.zIndex + 1;
									sortArray[i + 1].style.zIndex = sortArray[i + 1].style.zIndex - 1;
								}
							}
						}
						if(style.left === null) {
							this.setVueAttr(style, "left", "0px");
							this.setVueAttr(style, "top", "0px");
						}
					}
					if(code === "down") {
						zIndex--;
						if(zIndex === 0) {
							if(style.position !== '') {
								style.position = "";
							}
							this.setVueAttr(style, "zIndex", 0);
						} else {
							if(style.position !== 'absolute') {
								this.setVueAttr(style, "position", "absolute");
							}
						}
						for(let i = 0; i < sortArray.length; i++) {
							if(sortArray[i].id === this.state.activeComponent.id) {
								if(i > 0) {
									sortArray[i].style.zIndex = sortArray[i].style.zIndex - 1;
									sortArray[i - 1].style.zIndex = sortArray[i - 1].style.zIndex + 1;
								}
							}
						}
						if(style.left === null) {
							this.setVueAttr(style, "left", "0px");
							this.setVueAttr(style, "top", "0px");
						}
						this.setVueAttr(style, "zIndex", zIndex);
					}
					if(code === "top") {
						zIndex = this.getMaxZindex(this.props.components);
						if(style.position !== 'absolute') {
							this.setVueAttr(style, "position", "absolute");
						}
						this.setVueAttr(style, "zIndex", sortArray.length + 1);
						if(style.left === null) {
							this.setVueAttr(style, "left", "0px");
							this.setVueAttr(style, "top", "0px");
						}
					}
					if(code === "bottom") {
						if(style.position !== '') {
						}
						this.setVueAttr(style, "position", "relative");
						this.setVueAttr(style, "zIndex", 0);
						this.setVueAttr(style, "left", "0px");
						this.setVueAttr(style, "top", "0px");
						this.setVueAttr(style, "width", "auto");
						this.setVueAttr(style, "height", "auto");
					}
				}
			}
			changeBackground=()=> {
				this.openDlgPage("M::icMaterial/picList&id=", {
					title: this.props.keePage.title + '背景设置',
					size: '820',
				 
					top: "10vh",
					loadUrl: '/keeVueComponent/get?id=',
					po: this.props.keePage,
					extraParas: {
						po: this.props.keePage
					},
					onChanged(ret, form) {
						form.$emit("command", "close");
					}
				})
			}
			
			onOutResFileClick=()=> {
				
				// 计算外部依赖信息，然后再会写到app里面
				 
				if(window.currentAppInfo)
				{
					if(!window.currentAppInfo.map.resFileList)
					{
						window.currentAppInfo.map.resFileList=[];
					}
					
					let resFileList = JSON.parse(JSON.stringify(window.currentAppInfo.map.resFileList));
					
					this.openDlgPage("M::icMaterial/resFileList&id=", {
						title:  '外部资源依赖管理',
						size: '800', 
						top: "10vh",
						loadUrl: '/keeVueComponent/get?id=',
						po: {
							resFileList:resFileList
						},
					 
						cb(ret, form) { 
							window.currentAppInfo.map.resFileList = JSON.parse(ret);
							form.$emit("command", "close");
						}
					})
				}
				else
				{
					alert("error");
				}
				
			}
			
			
			
			onTopComponentSource=(event)=> {
				if(this.state.activeComponent  && this.state.activeComponent.name ) {
					if(this.state.activeComponent.type == "layout" || this.state.activeComponent.type == "form") {
						alert("只支持业务类和展示类组件在线编辑源码！");
						return;
					}
					let that = this;
					this.doRequest("/keeVueComponent/getByName?name=" + this.state.activeComponent.name, (ret)=> {
						that.openRightPage("M::jdcc.vueComponent/jsForm&id=" + ret.id, {
							title: ret.name + '组件源码',
							size: 'normal',
							width: '70%',
							isAutoClose:false,
							top: "1vh",
							loadUrl: '/keeVueComponent/get?id=' + ret.id,
							extraParas: {
								id: ret.id
							},
							onChanged(ret, form) {
								that.showMessage(ret);
								form.$emit("command", "close");
							}
						})
					})
				} else {
					alert("请先在画布去选中一个组件！")
				}
			}
		 
			onMouseWheel=(delta)=> {
				let state = JSON.parse(JSON.stringify(this.state));

				if(delta>0)
				{
					delta=1;
				}
				else
				{
					delta = -1;
				}

				//console.log(delta);
				let top0 = parseInt($('#feasReactApp').offset().top);
				let h = parseInt($('#feasReactApp').outerHeight());
				let h1 = parseInt($('#scrollBlockY').outerHeight());
				let top1 = parseInt($('#scrollBlockY').offset().top);
				// console.log("X:" + event.clientX + " Y:" + event.clientY + " " + (event.clientY - this.state.startPoint.y));
				let newPos =  state.currentY - delta * 15;
				if(newPos >= 0 && (newPos + h1) <= h) {
					state.currentY = newPos;
					state.styleY.transform = 'translateY(' + (newPos - 100) + 'px)';
					state.styleY['WebkitTransform'] = 'translateY(' + (newPos - 100) + 'px)';
					state.designerContentStyle.top = 6 * (0 - (newPos - 100)) + "px";
				}

				this.setState(state);

			}
			onBodyMouseUp=(event)=> {
				this.state.isShowSelectDiv = false;
				  
				// 比对两者的差异，然后同步到列表页面里面去
				
				$("body").off("mousemove");
				this.isDraging = false;
				this.sendEvent("drag.mousedown", false);
				this.state.isMoving = false;
				
				// 把所有的组件的isMoving都设置为return false;
				// 把所有的
			 
				
				if(this.state.activeComponent)
				{
					this.state.activeComponent.isMoving = false;
					
				}
				
				this.clearComponentMoving(this.props.components);
				let activeComponent = this.state.activeComponent;
				this.sendEvent("selectComponentToolBtn",{
					item:activeComponent
				}) 
				
				setTimeout(()=>{
					this.lastItem = "";
					
				},10);
				
				this.lastTargetId = "";
				this.lastBoxId = "";
				this.lastfangxiang  = "";
				
				
				
				
				console.log("mouse up event 11111");
				
				// 发送变更事件
				
				if($(event.target).hasClass("kee-design-content-div") == true || ($(event.target).parents(".kee-design-content-div").length > 0)) {
					this.sendEvent("changedComponents") 
				}
				this.refresh();
				

				//this.setState(this.state);
			}
			
			clearComponentMoving=(componentArray)=> {
				for(let i = 0; i < componentArray.length; i++) {
					componentArray[i].isMoving = false; 
					if(componentArray[i].child )
					{
						this.clearComponentMoving(componentArray[i].child );
					} 
				}
			}
			
			getEditorCurrentLine=(str)=>{
				let rowCol=window.editor.selection.getCursor();
				
				let lines = str.split('\n');
				let v = lines[rowCol.row].substr(0,rowCol.column);
				let p = v.trim();
				let ps = p.split(" ");
				return ps[ps.length-1];
				 
				
			}
			getCompleteItems=(prefix)=>{
				if(this.state.templateKeeVue===null)
				{
					this.state.templateKeeVue = new KeeVue({
							template: '<div></div>',
						});
				}
				let rows=[];
				let aliasList = [];
				this.getAllAliasExists(this.props.components,aliasList);
				let str = window.editor.getValue();
				// 计算当前行的文本
				let rowConent=this.getEditorCurrentLine(str);
				
				console.log("prefix:"+prefix+" stack："+this.fullPrefix+" index:"+rowConent);
				
				// 计算属性值
				if(rowConent.indexOf("this.")!=-1)
				{
					rowConent = rowConent.substr(rowConent.lastIndexOf("this."));
				}
				
				console.log("rowConent"+rowConent);
				
				let currentPageViewName = this.props.keePage.id+"huabu";
				
				window.fullPrefix = "";
				 
				if(rowConent.indexOf("this.")==0&&this.props.components&&this.props.components.length>0)
				{
					window.fullPrefix = "this.";
					// 重新结算
					 
					 let comp = window.CMap[currentPageViewName];
					 
					 if(!comp)
					 {
						 comp = window.CReactMap[currentPageViewName];
					 }
					 
					 let propField = rowConent.replace("this.","");
					
					 if(propField&&comp)
					 {
						 comp = this.getAttr(comp,propField);
						 
						 if(comp)
						 {
							 for(let p in comp)
							 {
							    //if(typeof comp[p]==="function")
							   // alert("push");
							   let type = typeof comp[p];
							  
							   
							 	rows.push({
							 		name: "zujian"+p, //名称
							 		value: ""+p,
							 		caption: p,
							 		meta: type,
							 		type: "keyword",
							 		score: 1000  
							 		 
							 	});
							 }
						 }
						 
						 
						  return rows;
						 
						 
					 }
					 
					
					 
					 
				}
				 
				
				if(prefix==="this.")
				{
					this.fullPrefix="this.";
					window.fullPrefix = "this.";
					
					// if(typeof this.state.aceCodeMethodKeyword[this.props.keePage.config.alias] === "undefined")
					// {
					// 	this.state.aceCodeMethodKeyword[this.props.keePage.config.alias]=[];
					// }
					// try{
						
					// 	 eval(str);
					// 	let temprows = [];
					// 	if(window.crudExt)
					// 	{
					// 		for(let p in window.crudExt)
					// 		{
					// 		if(p.indexOf(".")!==-1)
					// 		{
					// 			continue;
					// 		}
					// 			console.log(" 属性"+p+" ")
					// 			rows.push({
					// 			name: this.props.keePage.config.alias+""+p, //名称
					// 		value: ""+p,
					// 		caption: p,
					// 		meta: "extmethod",
					// 		type: "extmethod",
					// 		score: 1000 //
					// 			});
					// 		}
					// 	}
					// 	this.state.aceCodeMethodKeyword[this.props.keePage.config.alias] = temprows;
					// }
					// catch(e)
					// {
					// 	console.log(e);
					// }
					//rows = this.state.aceCodeMethodKeyword[this.props.keePage.config.alias];
					
					
					for(let i=0;i<aliasList.length;i++)
					{
						let p = aliasList[i];
						rows.push({
							name: "alias"+p.alias, //名称
							value: ""+p.alias,
							caption: p.alias,
							meta: "组件",
							type: "keyword",
							score: 1000,
							docHTML:"<div>"+p.name+"组件</div>",
						});
					}
					if(this.props.components  && this.props.components.length > 0) {
						 let page = window.CMap[currentPageViewName];
						 
						 if(!page)
						 {
						 	page = window.CReactMap[currentPageViewName];
						 }
						 
						 if(page)
						 for(let p in page)
						 {
						 	rows.push({
						 		name: "parent"+p, //名称
						 		value: ""+p,
						 		caption: p,
						 		meta: "页面"+(typeof page[p]),
						 		type: "keyword",
						 		score: 2000
						 	});
						 }
						
					}
					
				}
				for(let i=0;i<aliasList.length;i++)
				{
					if(prefix==aliasList[i].alias+".")
					{
						 
						 this.fullPrefix=this.fullPrefix+prefix;
						// let comp = this.$refs.designPager[aliasList[i]];
						
						if(rowConent.indexOf("this.")!=-1)
						{
							rowConent = rowConent.substr(rowConent.indexOf("this."));
						}
						console.log("rowContent:"+rowConent);
						rows = [];
					
						let targetComp = this.getComponentByAlias(this.props.components,aliasList[i].alias);
						console.log(targetComp);
						if(targetComp)
						{
							
						 let comp = window.CMap[currentPageViewName][targetComp.alias];
						 
						 if(!comp&&window.CReactMap[currentPageViewName])
						 {
							 comp = window.CReactMap[currentPageViewName][targetComp.alias];
						 }
						 console.log(comp);
						// alert("finded"+comp);
							for(let p in comp)
							{
							   //if(typeof comp[p]==="function")
							  // alert("push");
								rows.push({
									name: "zujian"+p, //名称
									value: ""+p,
									caption: p,
									meta: "parent",
									type: "keyword",
									score: 1000  
									 
								});
							}
							
							this.state.aceCodeMethodKeyword[this.props.keePage.config.alias] = rows;
						}
					}
				}
				if(prefix==="/"&& window.apiKeyList)
				{
					for(let i=0;i<window.apiKeyList.length;i++)
					{
					let p = window.apiKeyList[i];
						rows.push({
							name: "api_"+p, //名称
							value:  p,
							caption: p,
							meta: "api",
							type: "keyword",
							score: 1000 //
						});
					}
				}
				 return rows;
			}
			initEditor=()=> {

				let that = this;
				if(window.isReport )
				{
					return ;
				}
				window.editor = window.ace.edit("code");
				window.editor.setTheme("ace/theme/clouds");
				window.editor.session.setMode("ace/mode/javascript");
				window.editor.setFontSize(16);
				window.editor.setReadOnly(false);
				window.editor.setOption("wrap", "free")
				window.ace.require("ace/ext/language_tools");
				window.editor.setOptions({
					enableBasicAutocompletion: true,
					enableSnippets: true,
					enableLiveAutocompletion: true
				});
				let languageTools = window.ace.require("ace/ext/language_tools");
				let myCompleter = {
					getCompletions(editor, session, pos, prefix, callback) {
						//console.log("自定义补全收到：" + prefix);
						callback(null, that.getCompleteItems(prefix));
					}
				}
				window.myCompleter = myCompleter;
				languageTools.addCompleter(myCompleter);
					if(that.props.keePage)
					{
						window.editor.setValue(that.props.keePage.vueSource);
					}

					window.editor.clearSelection();
					window.editor.on("change",  (e)=> {
						if(this.props.keePage&&this.props.keePage.isSelected === true) {
							this.props.keePage.vueSource = window.editor.getValue();
							
							if(this.props.keePage.vueSource&&this.props.keePage.vueSource!=this.currentVueSource)
							{
								this.currentVueSource = this.props.keePage.vueSource;
								
								if(window.socketVueSource!=this.props.keePage.vueSource)
								{
									this.sendEvent("changedComponents");
								} 
							}
							
							
							
						}
					})
			}
			
			find=()=>{
							window.editor.execCommand("find");
			}
		  
			showLogInfo=()=> {
				console.log(JSON.stringify(this.props.keePage));
			}
			removeNotUserProperty=(componentArray)=>{
				for(let i=0;i<componentArray.length;i++)
				{
					delete componentArray[i].functions;
					delete componentArray[i].icon;
					delete componentArray[i].rect;
					delete componentArray[i].events;
					delete componentArray[i].isKeeShowBorder;
					delete componentArray[i].isMouseOver;
					
						
					delete componentArray[i].isSelected;
					delete componentArray[i].isAdding;
					delete componentArray[i].isMoving;
					delete componentArray[i].showChild;
					delete componentArray[i].children;
					delete componentArray[i].key;
					delete componentArray[i].createTime;
					delete componentArray[i].updateTime;
					delete componentArray[i].userId;
					delete componentArray[i].seq;
					delete componentArray[i].viewName;
					delete componentArray[i].checked;
					delete componentArray[i].showme;
					
					//这个不能删除
					//delete componentArray[i].actions;
					delete componentArray[i].lastPoint;
					
					
					if(componentArray[i].style)
					{
						delete componentArray[i].style.pointerEvents;	
						
						for(let p in  componentArray[i].style)
						{
							if(componentArray[i].style[p]==null||componentArray[i].style[p]==="")
							{
								//console.log("shanchu :"+p);
								delete componentArray[i].style[p];
							}
						}
					} 
					if(componentArray[i].child)
					{
						this.removeNotUserProperty(componentArray[i].child);
					}
					// if(componentArray[i].children)
					// {
					// 	this.removeNotUserProperty(componentArray[i].children);
					// }
					
				}
			}
			
			showComponentJsonPage=()=> {
				 
				 if(!this.jsonRightConfig)
				 {
					 this.jsonRightConfig = (<div><FsJsonConfig  ></FsJsonConfig></div>);
				 }
				 
				 this.sendEvent("showRightDrawer",this.jsonRightConfig);
				 
				 setTimeout(()=>{
					 this.sendEvent("showJsonRightConfig",this.props.components);
				 },50);
				 
				 
			}
			
			showComponentInfo=()=> {
				// if(this.state.activeComponent ) {
				// 	console.log(JSON.stringify(this.state.activeComponent))
				// } else {
				// 	alert("请先选择一个组件");
				// }
				
				 if(this.props.keePage&&this.jsonEditor) {
				 	//{"row":26,"column":30}
				 	//alert(JSON.stringify(editor.selection.getCursor()));
					let syncComponents = JSON.parse(JSON.stringify(this.props.components));
					this.removeNotUserProperty(syncComponents);
					let fjs = window.js_beautify(JSON.stringify(syncComponents), 1, "\t");
				 	this.jsonEditor.setValue(fjs);
				 
				 	this.jsonEditor.clearSelection();
				 	this.jsonEditor.moveCursorTo(0,0);
				 
				 }
				 
				 
				this.state.showJsonRight=true;
				this.refresh();
			}
			zoomIn=()=> {
				let state = JSON.parse(JSON.stringify(this.state));

				if(state.currentScale >= 300) {
					return;
				}
				state.currentScale = state.currentScale + 10;
				state.designerContentStyle["transform"] = "scale(" + (state.currentScale / 100) + ")";
				state.designerContentStyle["WebkitTransform"] = "scale(" + (state.currentScale / 100) + ")";
				window.currentScale = state.currentScale;
				this.sendEvent("currentScaleValue", state.currentScale);
				this.setState(state);
			}
			zoomOut=()=> {
				let state = JSON.parse(JSON.stringify(this.state));
				if(state.currentScale <= 20) {
					return;
				}
				state.currentScale = state.currentScale - 10;
				state.designerContentStyle["transform"] = "scale(" + (state.currentScale / 100) + ")";
				state.designerContentStyle["WebkitTransform"] = "scale(" + (state.currentScale / 100) + ")";
				window.currentScale = state.currentScale;
				this.sendEvent("currentScaleValue", state.currentScale);
				this.setState(state);

			}
			copyComponent=()=> {
				if(this.state.selectComponentItems.length > 0) {
					this.clipper.type = "copy";
					this.clipper.content = JSON.stringify(this.state.selectComponentItems);
					
					console.log("复制组件："+this.clipper.content);
					
				} else {
					this.showErrorMessage("请选择一个待复制的组件");
				}
			}
			cutComponent=()=> {
				if(this.state.activeComponent ) {
					this.clipper.type = "cut";
					this.clipper.content = JSON.stringify(this.state.activeComponent);
				} else {
				}
			}
			pasteComponent=()=> {
				
				if(this.clipper.content ) {
					
					//debugger;
					
					let newComponents = JSON.parse(this.clipper.content);
					
					
					 
				
					this.clearSelectedState(this.props.components);
					if(this.clipper.type === "cut") {
						for(let i = 0; i < this.state.selectComponentItems.length; i++) {
							this.removeFromArray(this.state.selectComponentItems[i], this.props.components);
						}
						this.clipper.content = null;
						this.clipper.type = "";
					}
					let maxZindex = this.getMaxZindex(this.props.components);
					this.state.selectComponentItems = [];
					this.state.selectComponentItems = newComponents;
					for(let n = 0; n < newComponents.length; n++) {
						for(let m = n; m < newComponents.length; m++) {
							if(newComponents[n].style.zIndex > newComponents[m].style.zIndex) {
								let tempn = newComponents[n];
								let tempm = newComponents[m];
								newComponents.remove(tempn);
								newComponents.remove(tempm);
								newComponents.insert(n, tempm);
								newComponents.insert(m, tempn);
							}
						}
					}
					for(let n = 0; n < newComponents.length; n++) {
						let newComponent = newComponents[n];
						newComponent.id = this.getRandString();
						
						if(newComponent.style.position === 'absolute')
						{
							newComponent.style.zIndex = maxZindex + n;
						}
						else
						{
							newComponent.style.zIndex ="";
						}
						
						if(newComponent.name=='fs-tabs-item')
						{
							newComponent.cp.name=this.getRandString();
						}
						
						
						newComponent.isSelected = true;
						
						if(window.isReport&&newComponent.type=='form')
						{ 
							newComponent.cp.field = "";
						}
						
						if(!this.props.keePage.componentSn||this.props.keePage.componentSn=="NaN")
						{
							this.props.keePage.componentSn=0; 
						}
						
					
						 
						
						if(this.state.activeComponent === null) {
							newComponent.id = this.getRandString();
							
							for(let i = 0; i < 10000000; i++) {
									this.props.keePage.componentSn++; 
									let alias = newComponent.name.replace("fs-", "").replace("el-", "").replace("feas-", "").replace("kee-", "") + this.props.keePage.componentSn;
									alias = alias.replace(/-/g,''); // 去掉-
									if(!this.isAliasExists(this.props.components, alias)) {
										newComponent.alias = alias;
										break;
									}  
							}
							 
							this.setNewIdValue(newComponent.child);
							console.log("添加到组件树列表222");
							this.props.components.push(newComponent);
							
						} else {
							let ret = this.addNewComponent(this.props.components, newComponent);
						}
						
						if(window.isReport&&newComponent.type=='form')
						{ 
							newComponent.cp.field = newComponent.alias;
						}
						
					}
					
					
					this.setActiveComponent(newComponents[0]);
					this.sendEvent("updateComponentProperty", null, newComponents[0]);
					//this.showMessage("操作完成！");
					this.refresh();
					this.sendEvent("createState");
				} else {
					this.showErrorMessage("无组件可粘贴，请先选择复制或剪切组件！");
				}
				this.sendEvent("componentsChange");
			}
			addNewComponent=(componentArray, newComponent)=> {
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					if(c.id === this.state.activeComponent.id) {
						newComponent.id = this.getRandString();
						
						if(!this.props.keePage.componentSn)
						{
							this.props.keePage.componentSn = 0;
						}
						console.log("this.props.keePage.componentSn"+this.props.keePage.componentSn);
						for(let t = 0; t < 10000000; t++) {
							
							
							this.props.keePage.componentSn++;
							let alias = newComponent.name.replace("fs-", "").replace("el-", "").replace("feas-", "").replace("kee-", "") + this.props.keePage.componentSn;
							alias = alias.replace(/-/g,''); // 去掉-
							if(!this.isAliasExists(this.props.components, alias)) {
								newComponent.alias = alias;
								break;
							} 
							
							
							
							// let alias = newComponent.alias + t;
							// if(!this.isAliasExists(this.props.components, alias)) {
							// 	newComponent.alias = alias;
							// 	break;
							// }
						}
						this.setNewIdValue(newComponent.child);
						if(this.state.activeComponent.isContainer === true && this.state.activeComponent.name !== "fs-table" && this.state.activeComponent.name !== newComponent.name) {
							if(this.state.activeComponent.child ) {
								this.state.activeComponent.child.push(newComponent);
							}
						} else {
							componentArray.splice(i + 1, 0, newComponent);
						}
						return true;
					} else {
						if(c.child ) {
							let ret = this.addNewComponent(c.child, newComponent);
							if(ret === true)
								return true;
						}
					}
				}
			}
			setNewIdValue=(componentArray)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						c.id = this.getRandString();
						for(let t = 0; t < 10000000; t++) {
							let alias = c.alias + t;
							if(!this.isAliasExists(this.props.components, alias)) {
								c.alias = alias;
								break;
							}
						}
						if(c.child ) {
							this.setNewIdValue(c.child);
						}
					}
				}
			}
			onMouseClick=(event)=> {
				
				 
				if(this.lastItem)
				{
					
					return ;
				}
				
				this.selectComponentItems = [];
				this.getSelectComponent(this.props.components, this.selectComponentItems);
				
				// if(this.selectComponentItems.length>0)
				// {
				// 	//开启了多选模式，直接返回
				// 	return ;
				// }
				
				 
				if(this.props.keePage === null || this.props.keePage.type !== 'M') {
					return;
				}
				 
				let target = this.getSelectComponentId(event);
				if(event.ctrlKey === true) {
					this.state.isCtrlKey = true;
				} else {
					this.state.isCtrlKey = false;
				}
				if(target ) {
					let tid = target.getAttribute("tid");
					 console.log("center：选中了组件：" + tid);
					let component = this.getComponentById(tid, this.props.components);
					
					if(this.selectComponentItems.length>1)
					{
						for(let s=0;s<this.selectComponentItems.length;s++)
						{
							if(component&&this.selectComponentItems[s].id==component.id)
							{
								return ;
							}
						}
					} 
					
					this.setActiveComponent(component)
					
					
					// console.log("center：选中了组件：" + component.style.position);
					this.sendEvent("select", {
						item: component
					});
					this.sendEvent("updateComponentProperty", event, component);
				} else {
					
					
					if(this.selectComponentItems.length>0)
					{
						this.sendEvent("updateComponentProperty", event, null); 
					}
					else
					{
						console.log("center：未选中组件：" );
						this.setActiveComponent(null);
						this.sendEvent("clearSelectState");
					}
					
					
				}
				
				this.state.lastTid = null;
				this.onMouseMove(event);
			}
			
			showKeeBorderState=(componentArray, state)=> {
			
							if(componentArray != null) {
								for(let i = 0; i < componentArray.length; i++) {
								
									if(this.state.activeComponent != null&&this.state.activeComponent.id==componentArray[i].id)
									{
									   
									}
									else
									{
										if(componentArray[i].isKeeShowBorder!==state)
										{
											componentArray[i].isKeeShowBorder = state;
											componentArray[i].isMouseOver = false;  
											
											this.sendEvent(componentArray[i].id+"-"+componentArray[i].name+".render");
											 
										}
										
										
									}
									this.showKeeBorderState(componentArray[i].child, state);
									
									
								
									
								}
							}
						}
			showKeeBorderOver=(componentArray, state)=> {
			
							if(componentArray != null) {
								for(let i = 0; i < componentArray.length; i++) {
								
									if(this.state.activeComponent != null&&this.state.activeComponent.id==componentArray[i].id)
									{
									   
									}
									else
									{
										if(componentArray[i].isKeeShowBorder!==state)
										{ 
											componentArray[i].isMouseOver = false;  
											
											this.sendEvent(componentArray[i].id+"-"+componentArray[i].name+".render");
											 
										}
										
										
									}
									this.showKeeBorderOver(componentArray[i].child, state);
									
									
								
									
								}
							}
						}
						
			onMouseMove=(event)=> {
						
						
							// if(this.isDraging)
							// {
							// 	return ;
							// }
						
						    
						     {
						     	let target = this.getSelectComponentId(event);
						     	
						     	let tid = "";
						     			 
								if(target != null) {
								  tid = target.getAttribute("tid");
								}
								// console.log("this.lastTid:"+this.lastTid+"--tid:"+tid);
								if(this.state.lastTid!=tid)
								{
									 if(this.state.isKeeShowBorder===false)
									{
										this.showKeeBorderState(this.props.components,false);
									}
									else
									{
										this.showKeeBorderOver(this.props.components,false);
										
									}
								 	
								 	this.state.lastTid = tid;
								 	
								 	if(target != null)
								 	{
								 		let component = this.getComponentById(tid, this.props.components);
								
										if(component)
										{
											component.isKeeShowBorder = true;
											
											 component.isMouseOver=true;
											//console.log("显示边框线"+component.id+"-"+component.name+".render")
											this.sendEvent(component.id+"-"+component.name+".render");
											//this.refresh();
										}
										
								 	}
									 
								 
								}else
								{
									//console.log("eq");
								}
						     }
							 
						}


			onMousedown=(event)=> {
				
			//	console.log("--------------------------------------")
				let state = JSON.parse(JSON.stringify(this.state));

				if(this.props.keePage === null || this.props.keePage.type !== 'M') {
					return;
				}
				state.isMoving = false;
				let target = this.getSelectComponentId(event);
				
				this.selectComponentItems = [];
				this.getSelectComponent(this.props.components, this.selectComponentItems);
				
				
			


				if(event.ctrlKey === true) {
					state.isCtrlKey = true;
				} else {
					state.isCtrlKey = false;
				}
				if(target ) {
					
					// 如果选中的目标已经处于选中态了
					
					let tid = target.getAttribute("tid");
					// console.log("center：选中了组件：" + tid);
					let component = this.getComponentById(tid, this.props.components);
					
					this.sendEvent("selectComponentToolBtn", {
						item: component
					});
					
					if(component&&component.isSelected)
					{
						 
					}
					else
					{
						// console.log("center：选中了组件2：" + component.style.position);
						if(component.isSelected !== true) {
							if(state.isCtrlKey ==false ) {
								this.clearSelectedState(this.props.components);
								component.isSelected = true;
							} else {
							}
						}
					}
					
					
					
					// let dragItem = $("#" + tid);
					// let left0 = parseInt(dragItem.offset().left);
					// let top0 = parseInt(dragItem.offset().top);
					// let width = parseInt(dragItem.width());
					// let height = parseInt(dragItem.height());
					
					//console.log("当前组件："+component.name+" x:"+event.clientX+" y:"+event.clientY+" cx："+left0+" cy："+top0+" "+width+" "+height );
					
					
					// this.sendEvent("showDirectDiv", event, component);
					// let btnNum = event.button;
					// if(btnNum === 2) {
					// 	event.preventDefault();
					// 	this.sendEvent("showComponentProperty", event, component);
					// } else {
					// 	this.sendEvent("updateComponentProperty", event, component);
					// }
				} else {
					
					this.sendEvent("selectComponentToolBtn", null);
					
					this.clearSelectedState(this.props.components);
					
					state.selectStartPoint.x0 = parseInt($('#designContentDiv').offset().left);
					state.selectStartPoint.y0 = parseInt($('#designContentDiv').offset().top);
					state.selectStartPoint.left = ((event.clientX - state.selectStartPoint.x0) * 100) / state.currentScale;
					state.selectStartPoint.top = ((event.clientY - state.selectStartPoint.y0) * 100) / state.currentScale;
					state.selectDivStyle.left = ((state.selectStartPoint.left - state.selectStartPoint.x0) * 100) / state.currentScale + "px";
					state.selectDivStyle.top = ((state.selectStartPoint.top - state.selectStartPoint.y0) * 100) / state.currentScale + "px";
					$("body").on("mousemove", this.onSelectDivMove);
				}
				state.selectComponentItems = [];
				
				
				this.getSelectComponent(this.props.components, state.selectComponentItems);
				
				if(state.selectComponentItems&&state.selectComponentItems.length>1)
				{
					window.selectManyComponents = true;
				}
				else
				{
					window.selectManyComponents = false;
				}
				
				this.sendEvent("drag.select", event, false);

				this.setState(state);

			}
			onSelectDivMove=(event)=> {
				let state = JSON.parse(JSON.stringify(this.state));
				state.isShowSelectDiv = true;
				let left = ((event.clientX - state.selectStartPoint.x0) * 100) / state.currentScale;
				let top = ((event.clientY - state.selectStartPoint.y0) * 100) / state.currentScale;
				let rect = {
					x: 0,
					y: 0,
					w: 0,
					h: 0,
				}
				if(left < state.selectStartPoint.left) {
					rect.x = left;
					rect.w = state.selectStartPoint.left - left
					state.selectDivStyle.left = (left) + "px";
					state.selectDivStyle.width = (rect.w) + "px";
				} else {
					rect.x = state.selectStartPoint.left;
					rect.w = left - state.selectStartPoint.left;
					state.selectDivStyle.left = (state.selectStartPoint.left) + "px";
					state.selectDivStyle.width = (left - state.selectStartPoint.left) + "px";
				}
				if(top < state.selectStartPoint.top) {
					rect.y = top;
					rect.h = state.selectStartPoint.top - top;
					state.selectDivStyle.top = (top) + "px";
					state.selectDivStyle.height = (state.selectStartPoint.top - top) + "px";
				} else {
					rect.y = state.selectStartPoint.top;
					rect.h = top - state.selectStartPoint.top;
					state.selectDivStyle.top = (state.selectStartPoint.top) + "px";
					state.selectDivStyle.height = (top - state.selectStartPoint.top) + "px";
				}
				if(rect.w > 5 || rect.h > 5) {
					state.isMoving = true;
					this.computerSelectedByRect(this.props.components, rect);
				}
				state.selectComponentItems = [];
				this.getSelectComponent(this.props.components, state.selectComponentItems);
				console.log("已选中：" + state.selectComponentItems.length + "个组件");
				console.log("已选中：" +this.props.controller.showReact+" "+window.isReport + "");
				
				if(state.selectComponentItems.length>1)
				{
					for(let ii=0;ii<state.selectComponentItems.length;ii++)
					{
						state.selectComponentItems[ii].isMoving = true;
					}
					
					window.selectManyComponents = true;
				}
				else
				{
					window.selectManyComponents = false;
				}
				
				this.setState(state);
			}
			computerSelectedByRect=(componentArray, rect)=> {
				let that = this;
				this.state.activeComponent = null;
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let component = componentArray[i];
						if(componentArray[i].style.position === 'absolute') {
							let style = {
								left: this.isNotBlank(component.style.left) ? parseInt(component.style.left.replace("px")) : 0,
								top: this.isNotBlank(component.style.top) ? parseInt(component.style.top.replace("px")) : 0,
								width: this.isNotBlank(component.style.width) ? parseInt(component.style.width.replace("px")) : 0,
								height: this.isNotBlank(component.style.height) ? parseInt(component.style.height.replace("px")) : 0,
							}
							if(style.left >= rect.x && (style.left + style.width) < (rect.x + rect.w) && style.top > rect.y && (style.top + style.height) < (rect.y + rect.h)) {
								componentArray[i].isSelected = true;
							} else {
								componentArray[i].isSelected = false;
							}
						}
						this.computerSelectedByRect(componentArray[i].child, rect);
					}
				}
			}
			onDrag=(obj)=> {
				
				if(this.props.keePage === null || this.props.keePage.type !== 'M') {
					return;
				}
				
				if(obj.pagenode)
				{
					return ;
				}
				
				this.state.currentComponent = null;
				this.lastBorderState = this.state.isKeeShowBorder;
				
				this.state.isKeeShowBorder = true;
				
				this.refresh();
				
				// if(this.state.isKeeShowBorder)
				// {
					
				// }
				
				this.moveComponent = null;
				if(this.props.components  && obj.tid ) {
					for(let i = 0; i < this.state.selectComponentItems.length; i++) {
						let selectItem = this.state.selectComponentItems[i];
						selectItem.lastPoint = {};
						if(selectItem.name === 'fs-box' || selectItem.style.position === 'absolute')
						  {
							if(this.isNotBlank(selectItem.style.left)) {
								selectItem.lastPoint.left = parseInt(selectItem.style.left.replace("px", ""));
							} else {
								selectItem.lastPoint.left = 0;
							}
							if(this.isNotBlank(selectItem.style.top)) {
								selectItem.lastPoint.top = parseInt(selectItem.style.top.replace("px", ""));
							} else {
								selectItem.lastPoint.top = 0;
							}
							if(this.isNotBlank(selectItem.style.right)) {
								selectItem.lastPoint.right = parseInt(selectItem.style.right.replace("px", ""));
							} else {
								selectItem.lastPoint.right = 0;
							}
							if(this.isNotBlank(selectItem.style.bottom)) {
								selectItem.lastPoint.bottom = parseInt(selectItem.style.bottom.replace("px", ""));
							} else {
								selectItem.lastPoint.bottom = 0;
							}
							if(selectItem.pid ) {
								let designContentDiv = $('#designContentDiv');
								let x0 = designContentDiv.offset().left;
								let y0 = designContentDiv.offset().top;
								let p = $("#" + selectItem.pid);
								let px0 = p.offset().left - x0;
								let py0 = p.offset().top - y0;
								selectItem.lastPoint.left = px0 + selectItem.lastPoint.left;
								selectItem.lastPoint.top = py0 + selectItem.lastPoint.top;
							}
						}
						this.sendEvent("select", {
							item: selectItem
						});
						selectItem.isMoving = true;
						this.refreshComponent(selectItem.id,selectItem.name);
						obj.callback(JSON.parse(JSON.stringify(selectItem)));
					}
				}
			}
			onBoxResize=(obj)=> {
				console.log("resize：：：：" + JSON.stringify(obj))
				let that = this;
				if(that.state.activeComponent  && (that.state.activeComponent.name === "fs-box" || that.state.activeComponent.style.position === 'absolute')) {
					let style = {
						left: this.isNotBlank(that.state.activeComponent.style.left) ? parseInt(that.state.activeComponent.style.left.replace("px")) : 0,
						top: this.isNotBlank(that.state.activeComponent.style.top) ? parseInt(that.state.activeComponent.style.top.replace("px")) : 0,
						right: this.isNotBlank(that.state.activeComponent.style.right) ? parseInt(that.state.activeComponent.style.right.replace("px")) : 0,
						bottom: this.isNotBlank(that.state.activeComponent.style.bottom) ? parseInt(that.state.activeComponent.style.bottom.replace("px")) : 0,
						width: this.isNotBlank(that.state.activeComponent.style.width) ? parseInt(that.state.activeComponent.style.width.replace("px")) : null,
						height: this.isNotBlank(that.state.activeComponent.style.height) ? parseInt(that.state.activeComponent.style.height.replace("px")) : null,
					}
					obj.offset.x = obj.offset.x * 100 / this.state.currentScale;
					obj.offset.y = obj.offset.y * 100 / this.state.currentScale;
					if(obj.direct === "top") {
						that.state.activeComponent.style.top = style.top + obj.offset.y + "px";
						if(style.height ) {
							that.state.activeComponent.style.height = style.height - obj.offset.y + "px";
						}
					}
					if(obj.direct === "left") {
						that.state.activeComponent.style.left = style.left + obj.offset.x + "px";
						if(style.width ) {
							that.state.activeComponent.style.width = style.width - obj.offset.x + "px";
						}
					}
					if(obj.direct === "right") {
						that.state.activeComponent.style.right = style.right - obj.offset.x + "px";
						if(style.width ) {
							that.state.activeComponent.style.width = style.width + obj.offset.x + "px";
						}
					}
					if(obj.direct === "bottom") {
						that.state.activeComponent.style.bottom = style.bottom - obj.offset.y + "px";
						if(style.height ) {
							that.state.activeComponent.style.height = style.height + obj.offset.y + "px";
						}
					}
				}
			}
			refreshContainerComponents=(componentArray)=> {
				
				let designContentDiv = $('#designContentDiv');
				let x0 = designContentDiv.offset().left;
				let y0 = designContentDiv.offset().top;
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						if(componentArray[i].isContainer === true||componentArray[i].name=='fs-pic') 
						{
							let dom = $("#" + componentArray[i].id);
							if(dom &&dom.offset()) {
								if(!componentArray[i].rect)
								{
									componentArray[i].rect={};
								}
								componentArray[i].rect.x = dom.offset().left - x0;
								componentArray[i].rect.y = dom.offset().top - y0;
								componentArray[i].rect.w = dom.width();
								componentArray[i].rect.h = dom.height();
							}
						}
						this.refreshContainerComponents(componentArray[i].child);
					}
				}
			}
			getParentContainerComponent=(componentArray, selectItem)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let parent = this.getParentContainerComponent(componentArray[i].child, selectItem);
						if(parent ) {
							return parent;
						}
						if(componentArray[i].isContainer === true&&componentArray[i].style.position!=="absolute") {
							let temp = componentArray[i];
							if(temp.name==='el-row'||(temp.name==='fs-table'&&temp.cp.showType==='card')||(temp.isContainer===true&&(temp.type!=='form'&&temp.type!=='layout')))
							{
								let rect0 = componentArray[i].rect;
								let rect = selectItem.rect;
								if((rect.x >= rect0.x && rect.x <= (rect0.x + rect0.w) && rect.y >= rect0.y && rect.y <= (rect0.y + rect0.h)) ||
									((rect.x + rect.w) >= rect0.x && (rect.x + rect.w) <= (rect0.x + rect0.w) && (rect.y + rect.h) >= rect0.y && (rect.y + rect.h) <= (rect0.y + rect0.h))) {
									return componentArray[i]
								}
							}
						}
					}
				}
				return null;
			}
			updateBoxPosition=(selectItem, obj)=> {
				console.log("更新fs-box的位置================================================================" );
				let w = parseInt($('#designContentDiv').width());
				let h = parseInt($('#designContentDiv').height());
				let designContentDiv = $('#designContentDiv');
				let x0 = designContentDiv.offset().left;
				let y0 = designContentDiv.offset().top;
				let dom = $("#" + selectItem.id);
				
				if(!selectItem.rect)
				{
					selectItem.rect={};
				}
				
				if(dom ) {
					console.log("计算坐标信息");
					
					if(typeof selectItem.pid !== "undefined" && selectItem.pid ) {
						console.log("计算坐标信息0");
						let p = $("#" + selectItem.pid);
						let px0 = p.offset().left - x0;
						let py0 = p.offset().top - y0;
						selectItem.style.left = (parseInt(selectItem.lastPoint.left + obj.moveX * 100 / this.state.currentScale) - px0) + "px";
						selectItem.style.top = (parseInt(selectItem.lastPoint.top + obj.moveY * 100 / this.state.currentScale) - py0) + "px";
						selectItem.style.right = parseInt(selectItem.lastPoint.right - obj.moveX) + "px";
						selectItem.style.bottom = parseInt(selectItem.lastPoint.bottom - obj.moveY) + "px";
						console.log("left:" + selectItem.style.left + " top:" + selectItem.style.top);
						if(this.isNotBlank(selectItem.style.width)) {
							let right = w - parseInt(selectItem.style.left.replace("px")) - parseInt(selectItem.style.width.replace("px"));
							selectItem.style.right = right + "px";
						}
						if(this.isNotBlank(selectItem.style.height)) {
							let bottom = h - parseInt(selectItem.style.top.replace("px")) - parseInt(selectItem.style.height.replace("px"));
							selectItem.style.bottom = bottom + "px";
						}
						selectItem.rect.x = px0 + parseInt(selectItem.style.left.replace("px"));
						selectItem.rect.y = py0 + parseInt(selectItem.style.top.replace("px"));
					} else {
						
						console.log("计算坐标信息1");
						selectItem.style.left = parseInt(selectItem.lastPoint.left + obj.moveX * 100 / this.state.currentScale) + "px";
						selectItem.style.top = parseInt(selectItem.lastPoint.top + obj.moveY * 100 / this.state.currentScale) + "px";
						selectItem.style.right = parseInt(selectItem.lastPoint.right - obj.moveX) + "px";
						selectItem.style.bottom = parseInt(selectItem.lastPoint.bottom - obj.moveY) + "px";
						console.log("left:" + selectItem.style.left + " top:" + selectItem.style.top);
						if(this.isNotBlank(selectItem.style.width)) {
							let right = w - parseInt(selectItem.style.left.replace("px")) - parseInt(selectItem.style.width.replace("px"));
							selectItem.style.right = right + "px";
						}
						if(this.isNotBlank(selectItem.style.height)) {
							let bottom = h - parseInt(selectItem.style.top.replace("px")) - parseInt(selectItem.style.height.replace("px"));
							selectItem.style.bottom = bottom + "px";
						}
						selectItem.rect.x = parseInt(selectItem.style.left.replace("px"));
						selectItem.rect.y = parseInt(selectItem.style.top.replace("px"));
					}
					selectItem.rect.w = dom.width();
					selectItem.rect.h = dom.height();
				}
				let target = this.getParentContainerComponent(this.props.components, selectItem);
				if(target ) {
					console.log("找到父容器：" + target.id + " " + target.name);
					if(selectItem.pid !== target.id && selectItem.id !== target.id) {
						this.removeFromArray(selectItem, this.props.components);
						target.child.push(selectItem);
						selectItem.pid = target.id;
						let p = $("#" + selectItem.pid);
						let px0 = p.offset().left - x0;
						let py0 = p.offset().top - y0;
						selectItem.style.left = (selectItem.rect.x - px0) + "px";
						selectItem.style.top = (selectItem.rect.y - py0) + "px";
					}
				} else {
						this.removeFromArray(selectItem, this.props.components);
						console.log("添加到组件树列表3333");
						this.props.components.push(selectItem);
						this.sendEvent("componentsChange");
					selectItem.pid = null;
					selectItem.style.left = (selectItem.rect.x) + "px";
					selectItem.style.top = (selectItem.rect.y) + "px";
					
					this.refresh();
				}
			}
			
			onLeftTreeDrop=(info)=>{ 
				
				let fromId = info.dragNode.key;
				let toId = info.node.key;
				
				let dropToGap = info.node.dropToGap;
				
				let position = info.dropPosition;
				
				let dragItem = this.getComponentById(fromId, this.props.components);
				let targetItem  = this.getComponentById(toId, this.props.components);
				let parentItem = this.getComponentParentById(toId,null,this.props.components);
				
				let child = this.props.components
				
				if(parentItem)
				{
					child  = parentItem.child;
				}
				 
				
				//表格列组件只能在表格组件，和表格列组件下面
				if(dragItem.name=='fs-table-col' && (!parentItem||parentItem.name!='fs-table'||parentItem.name!='fs-table-col'))
				{
					return ;
				}
				
				
				 
				 
					
					
					
					
					// 是一个组件，那么
					if(info.node.dragOver==true)
					{
						let isCanMove = true;
						if(targetItem.name=='fs-table'&&dragItem.name!='fs-table-col')
						{
							console.log("不能移动fs-table-col");
							isCanMove = false ;
						}
						//当是表格列时，如果不是表格或表格列组件，不能移动
						if((targetItem.name!='fs-table'&&targetItem!='fs-table-col')&&dragItem.name=='fs-table-col')
						{
							isCanMove = false ;
						}
						
						if(targetItem.isContainer&&isCanMove)
						{ 
							this.removeFromArray(dragItem, this.props.components);
							 
							targetItem.child.push(dragItem); 
						}
						else
						{
							this.removeFromArray(dragItem, this.props.components);
							for(let i=0;i<child.length;i++)
							{ 
								if(child[i].id==targetItem.id)
								{ 
									if(info.node.dragOverGapBottom)
									{
										console.log("插入后："+i);
										child.append(i,dragItem);
										break;
									}
									else
									{
											console.log("插入后："+i);
											child.insert(i,dragItem);
											break;
									} 
								} 
							}
						}
					}
					else
					{
						// 得找到这个节点的父节点
						
						if(parentItem&&parentItem.name=='fs-table' && dragItem.name!='fs-table-col')
						{
							console.log("不能移动table-col")
							return ;
						}
						
						
						 this.removeFromArray(dragItem, this.props.components);
						for(let i=0;i<child.length;i++)
						{
							 
								if(child[i].id==targetItem.id)
								{
									 
									
									if(info.node.dragOverGapBottom)
									{
										console.log("插入后："+i);
										child.append(i,dragItem);
										break;
									}
									else
									{
										console.log("插入后："+i);
										child.insert(i,dragItem);
										break;
									}
								 
										
									 
								}
							 
							
							
						}
					}
					
				 
				
				this.refresh();
				this.sendEvent("refreshTreeMenu")
				
				
				
				
			}
			
			onAddItem=(item)=>{
				 
				if(window.isReport)
				{
					this.state.currentComponent = item;
					let c = this.createNewComponent();
					
					c.isMoving = false;
					
					if(c.name=='fs-text')
					{
						c.cp.title = "文本";
						c.style.minWidth='50px';
					}
					
					this.props.components[2].child.push(c);
					this.refresh();
					// setTimeout(()=>{
					// 	alert($("#"+this.props.components[2].id).height());
						
					// },100);
					 
				}
			}
			
			recordLastStateObj =(obj)=>{
				//this.lastItem = dragItem;
				this.lastTargetId = obj.targetId;
				this.lastBoxId = obj.boxId;
				this.lastfangxiang = obj.fangxiang;
			}
			
			isHasContainer=(arr)=>{
				for(let i=0;arr&&i<arr.length;i++)
				{
					if(arr[i].isContainer)
					{
						return true;
					}
					if(arr[i].child&&this.isHasContainer(arr[i].child))
					{
						return true;
					}
				}
				return false;
			}
			
			onDraging=(dragInfo)=> {
				if(!dragInfo.count)
				{
					dragInfo.count = 1;
				}
				dragInfo.count++;
				
				if(!this.props.keePage   || this.props.keePage.type !== 'M') {
					console.log(!this.props.keePage   || this.props.keePage.type !== 'M');
					return;
				}
				
				if(dragInfo.pagenode)
				{
					console.log("dragInfo.pagenode = true")
					return ;
				}
				//当前鼠标位置
				let x = dragInfo.x;
				let y = dragInfo.y;
				let item = dragInfo.item;
				let targetId = dragInfo.targetId;
				//console.log("=============>>>>>>>>>>>> to targetId:::::::" + targetId)
				let boxId = dragInfo.boxId;
				// 如果相同的操作，就不处理了
				let dragItem = this.getComponentById(item.id, this.props.components);
				
				// console.log("移动鼠标事件。。。",dragInfo);
				// console.log("移动鼠标事件。。。",item.id,dragInfo.boxId);
				
				 
				 
				 let box = this.getComponentById(dragInfo.boxId, this.props.components);
				 
				 let boxObjtarget = box;
				 
				 // 如果容器里面有子容器，那么则不能直接放置功能组件
				 if(box&&box.child&&dragItem&&!dragItem.isContainer)
				 {
				 	box.child.map((item,index)=>{
				 		if(item.isContainer&&item.name=='el-col')
				 		{ 
							return ;
				 		}
				 	})
				 }
				 
				 
				 
				
				if(dragItem&&dragItem.isContainer&&(boxObjtarget&&boxObjtarget.name==dragItem.name&&(!(boxObjtarget.name=='fs-table-col')) ))
				{
					console.log("移动的组件是一个容器：");
					// 如果是一个容器，则需要获取上级的容器ID
					
					//
					let currentOverBox = this.getComponentById(boxId, this.props.components);
					
					// 如果这个容器没有子容器，则可以设置为target
					if(!this.isHasContainer(currentOverBox.child))
					{
						dragInfo.targetId = boxId;
					}
					
					
					
					let parentBox = this.getParentById(boxId, this.props.components, null);
					if(parentBox)
					{
						// 要升级一下
						dragInfo.boxId = parentBox.id;
					}
					else
					{
						//找不到说明到顶了
						dragInfo.boxId="workspace";
					}
					
					
				}
				
				//console.log("移动鼠标事件。。。",dragInfo);
				
				
				let toMoveInBoxItem = this.getComponentById(dragInfo.boxId, this.props.components);
				
				// if(toMoveInBoxItem)
				// {
				// 	console.log("在容器里面活动",toMoveInBoxItem);
				// }
				// else
				// {
				// 	console.log("默认在画布");
				// }
				
				  
				if( this.lastfangxiang===dragInfo.fangxiang&&this.lastTargetId===dragInfo.targetId&&this.lastBoxId===dragInfo.boxId&&(dragItem&&dragItem.style.position!="absolute"))
				{
					// 这里要判断，是否已经存在了
					
					let existsItem = false;
					if(toMoveInBoxItem)
					{
						for(let it=0;it<toMoveInBoxItem.length;it++)
						{
							if(toMoveInBoxItem[it].id==item.id)
							{
								existsItem = true;
								break;
							}
						} 
					}
					
					if(existsItem)
					{
						console.log("已处理过了");
						return ;
					}
					
					
				}
				
				 
				this.isDraging = true;

				this.state.isMoving = true;
			
				if(boxId === "fs-build-left1" || boxId === 'fs-build-right-pages') {
					console.log("r1")
					return;
				}
				if(item ) {
					//console.log("item:" + item.id);
					this.moveComponent = item;
				} else
				{
					console.log("r2");
					return;
				}
					
				if(item.contenteditable === true) {
					console.log("r3");
					return;
				}
				
				
				 //console.log("/keePage/getComponentPropForm?    寻找ID:"+item.id);
				

				if(this.newItem&&this.newItem.id==item.id)
				{
					dragItem = this.newItem;
				}
				
				
				
				
				
				

				//console.log("寻找组件："+item.id+" dragItem:"+(dragItem?true:false));
				// console.log("/keePage/getComponentPropForm?    找到:"+(dragItem?true:false));
				let exists = false;
				if(dragItem ) {
					if(dragItem.isSystem)
					{
						 
						return ;
					}
					
					dragItem.isMoving = true;
					exists = true;
					
					if(dragItem.name === "fs-box" || dragItem.style.position === 'absolute'  || (dragItem.isContainer===true&&(dragItem.type!=='form'&&dragItem.type!=='layout'))) {
						this.refreshContainerComponents(this.props.components);
						if(this.state.selectComponentItems.length > 1) {
							for(let m = 0; m < this.state.selectComponentItems.length; m++) {
								this.updateBoxPosition(this.state.selectComponentItems[m], dragInfo);
							}
						} else {
							console.log("dragItem方式移动");
							this.updateBoxPosition(dragItem, dragInfo);
						}
						
						console.log("recordLastStatedragInfo 返回");
						this.recordLastStateObj(dragInfo);
					 
						return;
					}
					
					
					
					console.log(dragInfo.item.id+"==="+dragInfo.boxId);
					
					if(dragInfo.item.id !== dragInfo.boxId) {
						
						 
						let canMove = true;
						if(dragItem.child ) {
							let mySelfComponent = this.getComponentById(dragInfo.boxId, dragItem.child);
							if(mySelfComponent ) {
								
								this.recordLastStateObj(dragInfo);
								console.log("recordLastStateObj 返回2");
								return;
							}
						}
						if(item.name === 'fs-tabs-item') {
							 document.body.style.cursor = "not-allowed";
							return;
						}
						// 判断父组件里面是否有子组件，是否全部是容器，
						let canput = true;
						if(box)
						{
							
						
						if(dragItem.isContainer )
						{
							// 如果是容器，那么判断目标boxId 是否有子容器；
							
							// 是否有子组件，有的话直接return 
							 
					       // console.log("当前移动的是容器:canput:"+canput+" 目标容器："+box.name);
							//可以嵌套自己的三个组件,box.name=='el-row'||box.name=='el-col'||,去掉row和col组件，不能直接嵌套
							if(box.name==dragItem.name&&!this.isHasContainer(box.child)&&(!(box.name=='fs-table-col')) )
							{
								// 这个应该找这个容器的上级
									canput = false ;
									
									this.lastOverBoxComponent = box;
									
									console.log("同名，且不是row:"+canput);
									
									//return ;
								 
								
							//	console.log("同名，且不是row:"+canput);
							}
							else
							{
								if(box.name=='fs-table-col'&&item.name=='fs-table-col'&&!box.cp.childColumn)
								{
									// 需要判断是否允许放子列表
									canput = false ;
								} 
							}
							
							// if(targetId)
							// {
							// 	canput = false;
							// //	console.log("移动到了组件:canput:"+canput);
							// }
							 
							//
							//console.log("当前移动的是容器:canput:"+canput+" 目标容器："+box.name);
							
							if(!canput)
							{
								// 向上找一级
								let parent = this.getParentById(box.id, this.props.components, null);
								
								dragInfo.targetId = box.id;
								box = parent;
								if(parent ) {
									dragInfo.boxId = parent.id;
									dragInfo.name = parent.name;
									
									// 然后再判断一次
									 
									
									for(let m=0;m<100&&parent;m++)
									{
										canput = true; 
										
										if(parent.name==dragItem.name )
										{
											if(parent.name=='fs-table-col'&&parent.cp.childColumn)
											{
												// 需要判断是否允许放子列表
												canput = true ;
											} 
											else
											{
												canput = false ;
											}
											
											
											console.log("name eq :dragItem.name :"+dragItem.name +" name:"+parent.name);
										}
										
										
										
										//console.log("找到父容器:canput:"+canput+" name:"+parent.name+" id:"+parent.id);
										if(!canput)
										{
											// 上级容器也不满足要求
										/*	parent = this.getParentById(parent.id, this.props.components, null);
											dragInfo.targetId = box.id;
											box = parent;*/
											break;
										}
										else
										{
											dragInfo.boxId = parent.id;
											dragInfo.name = parent.name;
											break;
										}
										
									}
									if(!canput)
									{
										 document.body.style.cursor = "not-allowed";
										 
										 this.recordLastStateObj(dragInfo);
										 
										 
										return ;
									}
									 
									
									 
								} else {
									dragInfo.boxId = "workspace";
									 
								}
							}
							
						 this.recordLastStateObj(dragInfo);
						 
							
							
						}
						else
						{
							// zujian ,如果有的话
							  canput = true;
							  //仅针对拖动的是功能组件生效
							if(box&&box.child&&!dragItem.isContainer)
							{
								box.child.map((item,index)=>{
									if(item.isContainer&&item.name=='el-col')
									{
										canput = false;
									}
								})
							}
							
							if(!canput)
							{
								 //document.body.style.cursor = "not-allowed";
								return ;
							}
							
							
						}
						
						}
						
						 
							
							// if( 'el-col'==dragItem.name&&(!box|| box.name !== 'el-row'))
							// {
							// 	console.log("列组件只能放在row组件里面");
							//  document.body.style.cursor = "not-allowed";
							// 	return;
								 
							// }
							
							if(!canput)
							{
								 document.body.style.cursor = "not-allowed";
							}
							
							
						 
						 
						// if(box&&box.name=='fs-table'&&item.name !== 'fs-table-col')
						// {
						// 	return ;
						// }
						if(item.name === 'fs-table-col') {
							if(box === null)
								canMove = false;
							if(box  && (box.name !== 'fs-table'&&box.name!=='fs-table-col'))
							{
								console.log("不能移动44444");
								canMove = false;
							}
							
							/* 需要加一个开关，控制是否支持多级表头
							if(box  && box.name === 'fs-table-col') {
								let parent = this.getParentById(box.id, this.props.components, null);
								dragInfo.targetId = box.id;
								if(parent ) {
									dragInfo.boxId = parent.id;
									dragInfo.name = parent.name;
									canMove = true;
								} else {
									 console.log("不能移动55555");
									canMove = false;
								}
							}*/
						}
						
						// if(box)
						// {
						// 	console.log("不能移动111111 box.name"+box.name+" item.nam:"+item.name);
						// }
						
						
						// 限制box为table时，且table的模式是表格模式，非卡片模式
						if(box&&item&&box.name=='fs-table'&&box.cp.showType!='card'&&item.name!='fs-table-col')
						{
							console.log("不能移动到表格组件里面，表格列组件除外");
							canMove = false;
						}
						
						//console.log("执行移动:"+canMove);
						if(canMove === true && item.name !== 'fs-box') {
							
							// document.body.style.cursor = "default";
							 
							//console.log("执行移动: targetId:"+dragInfo.targetId+" 容器："+dragInfo.boxId+",dragInfo.name="+dragInfo.name);
							let parent = this.getParentById(dragInfo.boxId , this.props.components, null); 
							if(parent ) {
								this.movingComponent(dragInfo, exists, dragItem, parent.child, parent.id,parent.name);
							}
							else
							{
								 
								this.movingComponent(dragInfo, exists, dragItem, this.props.components, "workspace");
								 
								
							}
							
							this.lastItem = dragItem;
							this.lastTargetId = dragInfo.targetId;
							this.lastBoxId = dragInfo.boxId;
							
							
							
							
							//this.sendEvent(that.props.po.id+".render");
							//this.refreshComponent(dragInfo.boxId,dragInfo.name);
							this.refresh();
						}
					}
				} else {
					this.state.currentComponent = dragInfo.item;
					if(this.state.currentComponent ) {
						console.log("center:创建新组件");
						let newItem = this.createNewComponent();
						if(newItem.name === "fs-layout") {
							let leftPanel = this.createNewComponent();
							leftPanel.cp.position = "left";
							let topPanel = this.createNewComponent();
							topPanel.cp.position = "top";
							let rightPanel = this.createNewComponent();
							rightPanel.cp.position = "right";
							let bottomPanel = this.createNewComponent();
							bottomPanel.cp.position = "bottom";
							let centerPanel = this.createNewComponent();
							centerPanel.cp.position = "center";
							newItem.child = [leftPanel, topPanel, rightPanel, bottomPanel, centerPanel];
							
							 
							leftPanel.isSelected = false;
							topPanel.isSelected = false;
							rightPanel.isSelected = false;
							bottomPanel.isSelected = false;
							centerPanel.isSelected = false;
							
							
							
							console.log("--------------fs-layout");
							newItem.style.position = "relative";
							newItem.style.width="100%";
							newItem.style.height="100%";
							
							newItem.style.left = "0";
							newItem.style.top = "0";
							newItem.style.right = "0";
							newItem.style.bottom = "0";
							console.log("--------------fs-layout"+newItem.style.position );
						}
						this.setActiveComponent(newItem);
						//console.log("新组件111：：：：："+JSON.stringify(newItem));
						if(newItem ) {
							dragInfo.item.id = newItem.id;
							this.newItem = newItem;
							if(newItem.name === 'fs-box'||newItem.name === 'fs-pic'  ) {
								dragInfo.startPoint.x = dragInfo.endPoint.x;
								dragInfo.startPoint.y = dragInfo.endPoint.y;
								if(!newItem.style.width)
								{
									newItem.style.width="300px";
								}
								if(!newItem.style.height)
								{
									newItem.style.height="200px";
								}
								let width = parseInt(newItem.style.width.replace("px", ""));
								let height = parseInt(newItem.style.height.replace("px", ""));
								let designContentDiv = $('#designContentDiv');
								let x0 = parseInt(designContentDiv.offset().left);
								let y0 = parseInt(designContentDiv.offset().top);
								console.log("执行到这里了：" + (dragInfo.endPoint.x - x0 - (width / 2)));
								newItem.style.left = ((dragInfo.endPoint.x - x0) * 100 / this.state.currentScale - (width / 2)) + designContentDiv.scrollLeft() + "px";
								newItem.style.top = ((dragInfo.endPoint.y - y0) * 100 / this.state.currentScale - (height / 2)) + designContentDiv.scrollTop() + "px";
								let w = parseInt(designContentDiv.width());
								let h = parseInt(designContentDiv.height());
								let right = w - parseInt(newItem.style.left.replace("px")) - parseInt(newItem.style.width.replace("px"));
								let bottom = h - parseInt(newItem.style.top.replace("px")) - parseInt(newItem.style.height.replace("px"));
								newItem.style.right = right + "px";
								newItem.style.bottom = bottom + "px";
								newItem.lastPoint = {
								};
								newItem.lastPoint.left = parseInt(newItem.style.left.replace("px", ""));
								newItem.lastPoint.top = parseInt(newItem.style.top.replace("px", ""));
								newItem.lastPoint.right = parseInt(newItem.style.right.replace("px", ""));
								newItem.lastPoint.bottom = parseInt(newItem.style.bottom.replace("px", ""));
								if(this.isNotBlank(newItem.style.left)) {
									this.state.fsBoxStartStyle.left = parseInt(newItem.style.left.replace("px", ""));
								} else {
									this.state.fsBoxStartStyle.left = 0;
								}
								if(this.isNotBlank(newItem.style.top)) {
									this.state.fsBoxStartStyle.top = parseInt(newItem.style.top.replace("px", ""));
								} else {
									this.state.fsBoxStartStyle.top = 0;
								}
								if(this.isNotBlank(newItem.style.right)) {
									this.state.fsBoxStartStyle.right = parseInt(newItem.style.right.replace("px", ""));
								} else {
									this.state.fsBoxStartStyle.right = 0;
								}
								if(this.isNotBlank(newItem.style.bottom)) {
									this.state.fsBoxStartStyle.bottom = parseInt(newItem.style.bottom.replace("px", ""));
								} else {
									this.state.fsBoxStartStyle.bottom = 0;
								}
								this.sendEvent("drag.updatePoint", dragInfo.startPoint);
								console.log("添加到组件树列表");
								this.props.components.push(newItem);
								this.sendEvent("componentsChange");
								 
							} else {
								if(dragInfo.item.id !== dragInfo.boxId) {
								let that = this;
								console.log("/keePage/getComponentPropForm?:movingComponent      "+newItem.style.position );
								
						 
									that.movingComponent(dragInfo, exists, newItem, that.props.components, "workspace");
								}
							}
						}
						this.refresh();
					}
					
				}
			    
				
			}
			onDroped=(obj)=> {
				
				if(this.props.keePage === null || this.props.keePage.type !== 'M') {
					return;
				}
				
				if(obj.pagenode)
				{
					return ;
				}
				
				let x = obj.x;
				let y = obj.y;
				let item = obj.item;
				if(item)
				{
					
					let targetId = obj.targetId;
					let boxId = obj.boxId;
					if(boxId === null || boxId === "fs-build-left1" || boxId === 'fs-build-right-pages') {
						return;
					}
					this.state.currentComponent = item;
					
					let existsComponent = this.getComponentById(item.id, this.props.components);
					if(!existsComponent  ) {
						console.log("center:创建新组件11111111");
						this.createNewComponent();
					}
					if(existsComponent)
					{
						existsComponent.isMoving = false;
					}
					
					
					this.sendEvent("select", {
						item: existsComponent
					});
					
					// 创建一个还原点
					this.sendEvent("createState");
				}
				this.state.isKeeShowBorder = this.lastBorderState;
				this.refresh();

			}
			
			isChildComponent=(children,lastBoxId)=>{
				
				for(let i=0;i<children.length;i++)
				{
					if(children[i].id==lastBoxId)
					{
						return true;
					}
					if(children[i].child)
					{
						let exists = this.isChildComponent(children[i].child,lastBoxId);
						if(exists)
						{
							return true;
						}
					}
				}
				return false;
				
			}
			
			movingComponent=(obj, exists, item, componentArray, thisBoxName,componentName)=>{
				
				// if(this.isYiDongFlag)
				// {
				// 	return ;
				// }
				
				this.isYiDongFlag = true;
				this.yidongComponent(obj, exists, item, componentArray, thisBoxName,componentName);
				
				
				// setTimeout(()=>{
				// 	this.isYiDongFlag=false;
					
				// },100);
			}
			
			
			yidongComponent=(obj, exists, item, componentArray, thisBoxName,componentName)=> {
				
				//console.log("movingComponent::"+obj.boxId+"=obj.name"+obj.name+",thisBoxName:"+thisBoxName+",componentName="+componentName);
				
				if(this.moveTimeout)
				{
					clearTimeout(this.moveTimeout); 
					this.moveTimeout = null;
				}
				else
				{
					// this.moveTimeout = setTimeout(()=>{
					// 	this.movingComponent(obj, exists, item, componentArray, thisBoxName,componentName);
					// },30);
					// return ;
				}
				
				
				
				let list = componentArray;
				let oldIndex = -1;
				let parentOldIndex = -1;
				// 要移动到哪个目标上面
				let targetId = obj.targetId;
				//  要移动到哪个box里面
				let boxId = obj.boxId;
				for(let j = 0; j < list.length; j++) {
					if(list[j].id == item.id  ) {
						oldIndex = j;
						exists = true;
						//console.log("当前顺序：" + oldIndex)
						break;
					}
					
				}
				
				//console.log("targetId::"+targetId+",oldIndex="+oldIndex);

				
				let that = this;
				
				let newItem = item;
				
				// 看看目标容器是否是这个
				if(boxId === thisBoxName) {
					
					if(window.isReport)
					{
						if(boxId=="workspace")
						{
							return ;
						}
					}
					
					if(oldIndex!=-1&&!targetId)
					{
						
						let designContentDiv = $('#designContentDiv');
						let x0 = designContentDiv.offset().left;
						let y0 = designContentDiv.offset().top;
						if(componentArray ) {
							for(let i = 0; i < componentArray.length; i++) {
								let cc = componentArray[i];
								if(componentArray[i].style.position != "absolute") 
								{
									let dom = $("#" + componentArray[i].id);
									if(dom &&dom.offset()) {
										if(!componentArray[i].rect)
										{
											componentArray[i].rect={};
										}
										cc.rect.x = dom.offset().left - x0;
										cc.rect.y = dom.offset().top - y0;
										cc.rect.w = dom.width();
										cc.rect.h = dom.height();
										
										//console.log("x:"+cc.rect.x+" y:"+cc.rect.y+" w:"+cc.rect.w+" h:"+cc.rect.h);
									}
								}
							 
							}
						}
						
						let mx = obj.x-x0;
						let my = obj.y-y0;
						// 看在哪个纵向区间，再看属于哪个横向区间
						
						let ycomponents = [];
						if(componentArray ) {
							for(let i = 0; i < componentArray.length; i++) {
								let cc = componentArray[i];
								if(componentArray[i].style.position != "absolute") 
								{
									if(cc.rect.y<=my&&my<=cc.rect.y+cc.rect.h)
									{
										//console.log("找到行")
										ycomponents.push(cc);
									} 
								}
							 
							}
						}
						
						if(ycomponents.length==0)
						{
							//console.log("没有找到行，应该是移动到了末尾，或是开头？")
						}
						
						// 
						
						
						//看谁最接近
						let minJuli = -1;
						let selectTarget = null;
						for(let i = 0; i < ycomponents.length; i++) {
							let cc = ycomponents[i];
							if(ycomponents[i].style.position != "absolute") 
							{
								let m = Math.abs(mx-cc.rect.x);
								
								if(!selectTarget)
								{
									selectTarget = cc;
									minJuli = m;
								}
								else
								{
									if(m<minJuli)
									{
										selectTarget = cc;
										minJuli = m;
									}
								} 
							} 
						}
						
						if(!selectTarget&&thisBoxName=="workspace")
						{ 
							//解决在顶层找不到target的问题
							selectTarget = this.lastOverBoxComponent;
						}
						
						//console.log("找到最近的节点：",selectTarget,"thisBoxName="+thisBoxName);
						
						if(selectTarget&&selectTarget.id!=newItem.id)
						{
							//that.removeFromArray(newItem, that.props.components);
							// 再看是在前还是在后
							if((obj.fangxiang=="up"||obj.fangxiang=="left")&&(mx<selectTarget.rect.x||my<=(selectTarget.rect.y+2)) )
							{ 
								for(let t=0;t<componentArray.length;t++)
								{
									if(componentArray[t].id==selectTarget.id)
									{
										if(t-1==oldIndex)
										{
											
										}
										else
										{
											that.removeFromArray(newItem, that.props.components);
											componentArray.insert(t, newItem);
										}
										
										break;
									}
								}
							}
							if(!(obj.fangxiang=="up"||obj.fangxiang=="left")&&(mx>selectTarget.rect.x+selectTarget.rect.w||my>(selectTarget.rect.y+selectTarget.rect.h-2))) 
							{
								for(let t=0;t<componentArray.length;t++)
								{
									if(componentArray[t].id==selectTarget.id)
									{
									
									    if(t+1==oldIndex)
									    {
									    	
									    }
									    else
									    {
									    	that.removeFromArray(newItem, that.props.components);
									    	componentArray.insert(t, newItem);
									    }	
										 
										break;
									}
								}
							}
						}
						
						
						
						//console.log("mouse x:"+(obj.x-x0)+" y:"+(obj.y-y0));
						
						//然后判断当前鼠标位置有没有进入哪个组件的横向范围
					
						// 需要计算出一个targetId出来
						
						return ;
					}
					
					//console.log(item.id+"当前目标targetId:" + obj.targetId+" boxId:"+boxId+"  thisBoxName:"+thisBoxName);
					
					if(targetId ) {
						 if(oldIndex==-1)
						 {
							 that.removeFromArray(newItem, that.props.components);
						  }
							for(let j = 0; j < list.length; j++) {
								if(list[j].id === targetId) {
							  
									if(oldIndex==-1)
									{
										//console.log("插入：" + n);
										list.insert(j, newItem);
										 
									}
									else
									{
										if(oldIndex > j&&(obj.fangxiang=='up'||obj.fangxiang=='left')) {
											that.removeFromArray(newItem, that.props.components);
											list.insert(j, newItem);
										} 
										
										if(oldIndex<j&&(obj.fangxiang=='right'||obj.fangxiang=='down')){
											that.removeFromArray(newItem, that.props.components);
											list.insert(j , newItem);
										}
										 
									} 
									break;
								}
							}
						 
					} else 
					
					{
						
						//  没有目标组件
						

						//console.log("/keePage/getComponentPropForm?:movingComponent 开始push,但是需要判断是否真的在最后"+newItem.id);
						let isInserted = false;
						
						let lastContainerIndex=-1;
						for(let j = 0; j < list.length; j++) {
							if(list[j].id == newItem.id  ) {
								lastContainerIndex = j; 
								oldIndex = j;
								break;
							} 
							else
							{
								if(this.isChildComponent(list[j].child,newItem.id))
								{
									lastContainerIndex = j;
									 
									//console.log("移动到新的容器：" + lastContainerIndex);
									break;
								}
							}  
						}
						//console.log("移动到新的容器： obj.boxId:" + obj.boxId+" ==== "+newItem.id);
						  
						// 要判断这个节点，是否已经在当前的list里面；
						//if(oldIndex==-1)
						
						if(oldIndex==-1)
						{
							//console.log("removeFromArray");
							that.removeFromArray(newItem, that.props.components);
						}
							
					
						 
					
						//console.log("移动到新的容器：this.lastBoxId:"+this.lastBoxId+":::obj.boxId="+obj.boxId)
						//if( this.lastBoxId!=obj.boxId)
						{
							//console.log("移动到新的容器：oldIndex:"+oldIndex)
							// 从一个容器到一个新的容器，找到了这个
						
							//console.log("移动到新的容器：" + lastContainerIndex);
							
							if(obj.fangxiang=="up"||obj.fangxiang=="left" )
							{
								// 上移
								if(oldIndex!=-1)
								{ 
									if(oldIndex>0)
									{
										console.log("removeFromArray，上移一个")
										that.removeFromArray(newItem, that.props.components);
										list.insert(oldIndex-1, newItem);
									}
									
									isInserted = true;
								}
								else
								{
									// 填在旧的容器前面
									if(lastContainerIndex!=-1)
									{
										//console.log("插入：" + n);
										list.insert(lastContainerIndex, newItem);
										isInserted = true;
									}
								}
								
								
							}
							else
							{
								// 下移
								// 插入到后面，如果鼠标在当前容器的里的话
								
								if(oldIndex!=-1)
								{
									if(oldIndex<list.length-1)
									{
										console.log("removeFromArray，下移一个")
										that.removeFromArray(newItem, that.props.components);
										list.insert(oldIndex+1, newItem); 
									}
									isInserted = true;
									
								}
								else
								{
									if(lastContainerIndex!=-1)
									{
										//console.log("插入：" + n);
										list.insert(lastContainerIndex+1, newItem);
										isInserted = true;
									}
									else
									{
										//放到第一个
										list.insert(0, newItem);
										isInserted = true;
									}
								}
								
							}
							
							if(isInserted)
							{
								return ;
							}
							
						}
						
						// 计算
						
						
						if(!isInserted) {

							//console.log("/keePage/getComponentPropForm?:movingComponent-追加到最后"+newItem.id);
							if(list.indexOf(newItem)==-1)
							{
								list.push(newItem);
							}
							
						 
						}
						
						//this.refreshComponent(thisBoxName,componentName);
					}
					return true;
				}
				//console.log("/keePage/getComponentPropForm?:movingComponent "+componentArray.length);
				for(let i = 0; i < componentArray.length; i++) {
					if(componentArray[i].child ) {
						if(this.yidongComponent(obj, exists, item, componentArray[i].child, componentArray[i].id,componentArray[i].name))
						{
							return true;
						}
					}
				}

			}
			clearSelectedState=(componentArray)=> {
				//console.log("清除选中状态");
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						
						componentArray[i].isMouseOver = false
						if(componentArray[i].isSelected!==false)
						{
							componentArray[i].isSelected = false;
							
							if( this.state.isKeeShowBorder==false)
							{
								componentArray[i].isKeeShowBorder = false;
							}
							this.refreshComponent(componentArray[i].id,componentArray[i].name)
						}
						
						
						this.clearSelectedState(componentArray[i].child);
					}
				}
			}
			getSelectComponent=(componentArray, selectComponents)=> {
				for(let i = 0; i < componentArray.length; i++) {
					if(componentArray[i].isSelected) {
						selectComponents.push(componentArray[i]);
					}
					this.getSelectComponent(componentArray[i].child, selectComponents);
				}
			}
			setActiveComponent=(component)=> {
				let that = this;
				
				console.log("设置激活组件：");

				if(component!=null)
				{
				   component = this.getComponentById(component.id, this.props.components);
					  
				   console.log("设置当前组件："+(component?component.alias:'空组件'));
				}
				
				this.sendEvent("selectComponentToolBtn", {
					item: component
				});

				 

				//console.log("shoudao active event");

				if(!component&&this.state.activeComponent)
				{
					this.state.activeComponent.isSelected = false;
				}

				if(!component)
				{
					that.clearSelectedState(this.props.components);
				}



				if(this.state.isCtrlKey ) {
					{
						that.clearSelectedState(this.props.components);
						that.state.activeComponent = component;
						console.log("+++++++++++++++++++:" + component);
						if(component ) {
							that.state.activeComponent.isSelected = true;
							console.log("选中组件：：：：" + component.id)
						} else {
							that.clearSelectedState(this.props.components);
						}
						that.updateActiveDivStyle();
					}
				} else {
					if(component  && component.style.position === "absolute") {
						component.isSelected = !component.isSelected;
						 
					}
					this.clearSelectedState(this.props.components);
					if(component   ) {
						component.isSelected = true;
						component.isKeeShowBorder = true;
						that.state.activeComponent = component;
						this.refreshComponent(component.id,component.name);
					} else {
						that.state.activeComponent = null;
						this.refresh();
					}
					
					that.updateActiveDivStyle();
				}
				this.state.selectComponentItems = [];
				this.getSelectComponent(this.props.components, this.state.selectComponentItems);

				 
			}
			updateActiveDivStyle=()=> {
				let that = this;
				if(this.state.activeComponent ) {
					setTimeout(function() {
						if(that.state.activeComponent === null||!($('#designContentDiv').offset()))
							return;
						let x0 = parseInt($('#designContentDiv').offset().left);
						let y0 = parseInt($('#designContentDiv').offset().top);
						if($('#' + that.state.activeComponent.id).offset() ) {
							let x = parseInt($('#' + that.state.activeComponent.id).offset().left);
							let y = parseInt($('#' + that.state.activeComponent.id).offset().top);
							let w = parseInt($('#' + that.state.activeComponent.id).outerWidth());
							let h = parseInt($('#' + that.state.activeComponent.id).outerHeight());
							that.state.activeDivStyle.left = x - x0 - 1 + $('#designContentDiv').scrollLeft();
							that.state.activeDivStyle.top = y - y0 - 1 + $('#designContentDiv').scrollTop();
							that.state.activeDivStyle.width = w;
							that.state.activeDivStyle.height = h;
						}
						that.state.showActiveRedBorder = true;
					}, 10);
				}
			}
			getAllAliasExists=(componentArray, aliasList)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						aliasList.push(c);
						if(c.child ) {
							 this.getAllAliasExists(c.child, aliasList);
						}
					}
				}
			}
			getComponentByAlias=(componentArray, aliasName)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(c.alias === aliasName) {
							return c;
						}
						if(c.child ) {
							let ret = this.getComponentByAlias(c.child, aliasName);
							if(ret)
								return ret;
						}
					}
					return false;
				}
				return false;
			}
			isAliasExists=(componentArray, aliasName)=> {
				 
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(c.alias === aliasName) {
							return true;
						}
						if(c.child ) {
							let ret = this.isAliasExists(c.child, aliasName);
							if(ret === true)
								return ret;
						}
					}
					return false;
				}
				return false;
			}
			createNewComponent=(callback)=> {
				let x = 0;
				let y = 0;
				let w = parseInt($('#designContentDiv').width());
				let h = parseInt($('#designContentDiv').height());
				console.log("x:" + x + "y:" + y + "w:" + w + "h:" + h);
				let X = 0;
				let Y = 0;
				if(this.state.currentComponent ) {
					let that = this;
					let c = null;
					let display = "block";
					if(this.state.currentComponent.name === 'fs-text' || this.state.currentComponent.name === 'fs-drop' || this.state.currentComponent.name === 'fs-dropdown' || this.state.currentComponent.name === 'el-button') {
						display = "inline-block";
					}
					if(this.state.currentComponent.name === 'kee-div') {
						c = $.extend({
							style: $.extend({}, that.moveDivStyle, {
								display: display,
								left: X - x - that.moveDivStyle.width / 2 - 1,
								top: Y - y - that.moveDivStyle.height / 2 - 1,
								position: 'absolute',
							}),
							alias: this.getRandString(), // 别名
							cp: {},
							value: ''
						}, that.state.currentComponent, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
					} else {
						c = $.extend({
							style: $.extend({}, {
								display: display,
							}),
							cp: {},
							alias: this.getRandString(), // 别名
							value: ''
						}, that.state.currentComponent, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
					}
					
					if(this.state.currentComponent.name === 'fs-layout')
					{
						c.style.position = "absolute";
					}
					// 设置所属页面的CMap
					c.viewName = this.props.keePage.id+"huabu";
					
					c.createUserId = window.currentUserId;
					
					// 更新唯一标识逻辑，组件名字+组件自增编号
					if(!this.props.keePage.componentSn)
					{
						this.props.keePage.componentSn = 0;
					}
					for(let i = 0; i < 10000000; i++) {
						
						this.props.keePage.componentSn++;
						let alias = this.state.currentComponent.name.replace("fs-", "").replace("el-", "").replace("feas-", "").replace("kee-", "") + this.props.keePage.componentSn;
						alias = alias.replace(/-/g,''); // 去掉所有的-
						if(!this.isAliasExists(this.props.components, alias)) {
							c.alias = alias;
							break;
						} 
					}
					
					if(window.isReport&&c.type=='form')
					{
						c.cp.field = c.alias;
					}
					
					let name = this.state.currentComponent.name;
					for(let p in window.allPropConfig)
						{
							//console.log(p);
						}
					let houzhui="";
					if(window.isReport)
					{
						houzhui+="-report";
					}
					if(window.allPropConfig[name + "-prop-form"+houzhui])
					{
						that.initComponentByFormField(c, window.allPropConfig[name + "-prop-form"+houzhui]);
					}
					else
					{
				 	 //console.log("/keePage/getComponentPropForm?code="+name+"   randId:"+this.state.randId);
						this.doRequest("/keePage/getComponentPropForm?code="+name+"&houzhui="+houzhui,function(ret){

						for(let p in ret)
						{
							window.allPropConfig[p]=ret[p];
						}
						that.initComponentByFormField(c, window.allPropConfig[name + "-prop-form"+houzhui]);
						if(window.isReport)
						{
							c.cp.isShowTitle = true;
						}
 
						that.refresh();
						});
					}
					that.initComponentByFormField(c, window.allPropConfig["common-component-prop-form"]);
					
					c.title = this.state.currentComponent.title;
					
					if( c.style.position === "absolute"||c.name=='fs-pic' ) {
						this.setVueAttr(c.style, "left", "0px");
						this.setVueAttr(c.style, "top", "0px");
						this.setVueAttr(c.style, "right", "0px");
						this.setVueAttr(c.style, "bottom", "0px");
						this.setVueAttr(c.style, "width", "300px");
						this.setVueAttr(c.style, "height", "200px");
						this.setVueAttr(c.style, "position", "absolute");
						this.setVueAttr(c.style, "overflow", "visiable");
						let maxZindex = this.getMaxZindex(this.props.components);
						this.setVueAttr(c.style, "zIndex", maxZindex);
					}
					c.isKeeShowBorder = true;
					c.isSelected = true;
					c.isMouseOver = false;
					c.visiable = true;
					c.isMoving = true;
					c.isAdding = true; // 设置正在添加为true
					
					this.sendEvent("addComponent",c);
					return c;
				}
			}
			initComponentByFormField=(c, data)=> {
			 
				if(!data)
					return;
				for(let i = 0; i < data.length; i++) {
					let field = data[i];
					if(field.child  && field.child.length > 0) {
						this.initComponentByFormField(c, field.child);
					} else {
						if(field.cp  && this.isNotBlank(field.cp.field)) {
							let defaultValue = null;
							if(this.isNotBlank(field.cp.defaultValue)) {
								if(field.name === "fs-switch") {
									if(field.cp.defaultValue === "true"||field.cp.defaultValue === true)
										defaultValue = true; 
									if(field.cp.defaultValue === "false"||field.cp.defaultValue === false)
										defaultValue = false;
								} else {
									if(field.name === 'fs-text' && this.isNotBlank(field.cp.defaultValue) && !isNaN(field.cp.defaultValue)) {
										defaultValue = parseInt(field.cp.defaultValue);
									} else {
										defaultValue = field.cp.defaultValue;
									}
								}
							}
							console.log("this.getValueByAttr(c, field.cp.field):"+this.getValueByAttr(c, field.cp.field));
							if(this.isNotBlank(this.getValueByAttr(c, field.cp.field)) != true) {
								this.setVueAttr(c, field.cp.field, defaultValue);
							}
							
						}
					}
				}
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				this.sendEvent("command", cmdName, item, po, thisForm, parentForm);
			}
			
			$confirm(t1, t2, obj) {
				MessageBox.confirm(t1, t2, obj).then(() => {
					obj.callback("confirm", this);
			
				}).catch(() => {
					// Message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			
			
			}
			
			deleteComponent=()=> {
				if(window.isReport)
				{
					this.$confirm("删除该组件后，该组件记录数据将会全部消失","提示",{
						callback:()=>{
							for(let i = 0; i < this.state.selectComponentItems.length; i++) {
								this.removeFromArray(this.state.selectComponentItems[i], this.props.components);
								//this.sendEvent("deleteComponent",this.state.selectComponentItems[i]);
							}
							this.state.activeComponent = null;
							this.setActiveComponent(null);
							this.sendEvent("clearSelectState");
							this.sendEvent("componentsChange");
							this.sendEvent("createState");
						}
					})
				}
				else
				{
					for(let i = 0; i < this.state.selectComponentItems.length; i++) {
						this.removeFromArray(this.state.selectComponentItems[i], this.props.components);
						//this.sendEvent("deleteComponent",this.state.selectComponentItems[i]);
					}
					this.state.activeComponent = null;
					this.setActiveComponent(null);
					this.sendEvent("clearSelectState");
					this.sendEvent("componentsChange");
					this.sendEvent("createState");
					this.refresh();
				}
				
				
				
			}

			onScroll=()=> {
				let that = this;
			}
			pageFieldChange=(type)=> {
				if(!this.props.keePage)
				{
					return ;
				}
				if(!type)
				{
					  type = this.props.keePage.config.pageType;
				}
				else
				{
					 
					if(type === "full") {
						 
														this.props.keePage.config.width = "1000px";
														 
														this.props.keePage.config.height = "2200px";
														if(window.isReport)
														{
															this.props.keePage.config.width = "700px";
															this.props.keePage.components[2].style.display='block';
															this.props.keePage.components[2].style.width="100%";
															this.props.keePage.components[2].style.maxWidth="800px";
															
															// this.props.keePage.components[2].style.minHeight="1200px";
															
															this.props.keePage.components[2].style.margin="25px auto";
															 
														}
														
													}
													if(type === "dialog") {
														this.props.keePage.config.width = "700px";
														this.props.keePage.config.height = "400px";
													}
													if(type === "mobile") {
														this.props.keePage.config.width = "450px";
														this.props.keePage.config.height = "1200px";
														
														if(window.isReport)
														{
															this.props.keePage.components[2].style.display='block';
															this.props.keePage.components[2].style.width="100%";
															this.props.keePage.components[2].style.maxWidth="800px";
															// this.props.keePage.components[2].style.minHeight="1200px";
															this.props.keePage.components[2].style.margin="25px auto";
														}
														
													}
				}
				
						if(window.isReport)
						{
						 
							// this.props.keePage.components[2].style.minHeight="1200px";
							
						  
						}
				
				let designerContentStyle = JSON.parse(JSON.stringify(this.state.designerContentStyle));
				if(type === "full") {
					// designerContentStyle.position = "absolute";
					 designerContentStyle.left = 10 + "px";
					 designerContentStyle.top = 0 + "px";
					 designerContentStyle.right = 10 + "px";
					 designerContentStyle.marginBottom = 300+"px";
					designerContentStyle.marginTop = 60 + "px";
					designerContentStyle.marginLeft = "auto";
					designerContentStyle.marginRight = "auto";
					if(this.isNotBlank(this.props.keePage.config.width)) {
						designerContentStyle.width = this.props.keePage.config.width;
					} else {
						designerContentStyle.width = "1000px"
						
					}
					if(window.isReport)
					{
						designerContentStyle.width = "90%";
					}
					
					if(this.isNotBlank(this.props.keePage.config.height)) {
						designerContentStyle.minHeight = this.props.keePage.config.height;
					} else {
						designerContentStyle.minHeight = "1200px"
					}
				}
				if(type === "dialog") {
					designerContentStyle.position = "absolute";
					designerContentStyle.top = 0 + "px";
					designerContentStyle.bottom = "";
					designerContentStyle.marginTop = 60 + "px";
					designerContentStyle.width = this.props.keePage.config.widthDlg;
					designerContentStyle.width = this.props.keePage.config.width;
					designerContentStyle.minHeight = this.props.keePage.config.height;
					let left = ($("#designContentDiv").width - parseInt(designerContentStyle.width)) / 2;
					designerContentStyle.left = left + "px";
					designerContentStyle.right = left + "px";
					designerContentStyle.marginLeft = "auto";
					designerContentStyle.marginRight = "auto";
					designerContentStyle.marginBottom = 100 + "px";
				}
				if(type === "mobile") {
					designerContentStyle.position = "relative";
					 designerContentStyle.top = 0 + "px";
					designerContentStyle.bottom = "";
					designerContentStyle.width = this.props.keePage.config.width;
					designerContentStyle.minHeight = this.props.keePage.config.height;
					designerContentStyle.height = this.props.keePage.config.height;
					let left = ($("#designContentDiv").width - parseInt(designerContentStyle.width)) / 2;
					designerContentStyle.left = left + "px";
					designerContentStyle.right = left + "px";
					designerContentStyle.marginTop = 60 + "px";
					designerContentStyle.marginLeft = "auto";
					designerContentStyle.marginRight = "auto";
					designerContentStyle.marginBottom = "300px";
					
					if(window.isReport)
					{
						designerContentStyle.width = "350px";
					}
					
				}
designerContentStyle.position = "absolute";
designerContentStyle.paddingBottom="0px";
				//console.log(JSON.stringify(designerContentStyle));

				this.setState({
					designerContentStyle:designerContentStyle
				});
			}
			getParentById=(id, fromComponents, parent)=> {
				for(let i = 0; i < fromComponents.length; i++) {
					let c = fromComponents[i];
					if(c.id === id) {
						return parent;
					}
					if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
						let target = this.getParentById(id, c.child, c);
						if(target )
							return target;
					}
				}
				return null;
			}
			

			shouldComponentUpdate(nextProps, nextState) {

				//if(this.lastStateString ===(JSON.stringify(nextState)+JSON.stringify(nextProps)))
				{
					//console.log("重新渲染center。js::::false")
					//return false;
				}
				return true;

			   //  if (nextState.componentTypes===this.state.componentTypes) {

			   //    return false;
			   //  }
			   //  return true;
			}

			componentWillReceiveProps(nextProps){
					//	  console.log("触发更新center")
							  let that = this;
						if(this.vueApp)
						{
							// alert("show"+nextProps.components);
							
							console.log("切换：："+nextProps.keePage.id);
							
							this.vueApp.showPage( nextProps.components, nextProps.keePage, nextProps.activeComponent);
						}
						

							 	//{"row":26,"column":30}
							 	//alert(JSON.stringify(editor.selection.getCursor()));
								
						if(window.editor&&nextProps.keePage.vueSource!=window.editor.getValue())
						{
							window.editor.setValue(nextProps.keePage.vueSource);

							window.editor.clearSelection();
							window.editor.moveCursorTo(0,0);
						}
						
						// 每秒生成一个延时缩略的能力
						
						// if(this.canvasTimer)
						// {
						// 	clearTimeout(this.canvasTimer);
						// }
						
						// if(this.lastStateString != JSON.stringify(this.state)+JSON.stringify(nextProps))
						// {
						// 	this.canvasTimer = setTimeout(()=>{
						// 		this.genPageImg(nextProps.keePage)
						// 	},500);
						// }
						
						
						



			}
			
			// genPageImg=(currentPage)=>{
			// 	let dom = document.getElementById("designContentDiv");
			// 	html2canvas(dom, {
			// 	  width: dom.clientWidth,
			// 	  height: dom.clientHeight,
			// 	  scrollY: 0,
			// 	  scrollX: 0,
			// 	}).then(canvas => {
			// 	  let tempSrc = canvas.toDataURL('image/jpg');
			// 	  //console.log("imgimg:"+tempSrc);
			// 	  currentPage.imgSrc = tempSrc; 
				  
			// 	});
			// }

			showVueSource=(vs)=>{
				this.props.controller.showSource=(vs===true);
				
				if(this.currentPage!=this.props.keePage)
				{
					if(this.props.keePage) {
						//{"row":26,"column":30}
						//alert(JSON.stringify(editor.selection.getCursor()));
						window.editor.setValue(this.props.keePage.vueSource);
					
						window.editor.clearSelection();
						window.editor.moveCursorTo(0,0);
					
					}
					
					this.setState(this.state);
					this.currentPage=this.props.keePage
				}
				else
				{
					// do nothing
				}
				
			}
			
			showReact=(vs)=>{
				this.props.controller.showReact=(vs===true);
				 
				this.setState(this.state);
			}
			

  render(){
	  
	   
		  // console.log("重新渲染center。js"+(this.lastPropsComps === this.props.components));
	   
	  // this.lastPropsComps = this.props.components;
	  // console.log("重新渲染center。js",this.props.components)
	  //this.lastStateString = JSON.stringify(this.state)+JSON.stringify(this.props);
  return(

<div   id={this.state.randId} className={`jdcc-disable-select`} >
 { /*  <div style={{position:' absolute', top:' 0', left:' 0', right:' 0', height:' 49px', borderBottom:' 1px solid #CCCCCC'}} >
        <div style={{paddingLeft:' 5px',marginTop:' 10px',marginLeft:' 5px',lineHeight:' 36px'}} >
            <div className={`kee-left`} style={{width:' 60px'}} >
                <Button type="danger" size="mini" onClick={this.deleteComponent} ><i className={`el-icon-delete`}></i></Button>
            </div>
            <div className={`kee-left`} style={{width:' 60px'}} >
                <Button type="danger" size="mini"   onClick={this.showLogInfo} ><i className={`el-icon-search`}></i></Button>
            </div>
            <div className={`kee-left`} style={{width:' 60px'}} >
                <Button type="danger" size="mini"   onClick={this.showComponentJsonPage} >JSON</Button>
            </div>
            <div className={`kee-left`} style={{width:' 60px'}} >
                <Button type="primary" size="mini" onClick={this.changeBackground} >
                背景
                </Button>
            </div>

			<div style={{float:'right',marginRight:'30px',marginTop:'10px '}} >
			                <Button size="mini" type={this.state.showJsonRight===false&&this.props.controller.showSource!=true?'primary':'info'} onClick={()=>{this.state.showJsonRight=false;this.props.controller.showSource=false;this.setState(this.state)}} >
			                界面
			                </Button>
			                <Button size="mini" type={this.state.showJsonRight===false&&this.props.controller.showSource===true?'primary':'info'} onClick={()=>{this.state.showJsonRight=false;this.showVueSource()}} >
			                源码
			                </Button>
							 
			 </div>


        </div>
    </div>*/}
	
	
    <div   id="feasReactApp"  onClick={this.onMouseClick} 
	style={{'display':(this.props.controller.showCenterPage=='huabu'?'block':'none'),position:' absolute',zIndex:10, top:' 0px', left:' 0', bottom:' 0', right:' 0', background:' #fafafa', overflow:'auto' }} >
     
	  <div id="designContentDiv" boxid="workspace" className={`kee-design-content-div  jdccScaleDiv`} 
	       style={this.state.designerContentStyle} >
	    
		    { (this.props.controller.showReact===true||window.isReport)&&(this.props.controller.showReact===true||window.isReport)&&<div style={{display:( this.props.controller.showReact===true||window.isReport?'block':'none'), minHeight:this.state.designerContentStyle.minHeight}}>	
			 
			<FeasPage   components={this.props.components} keePage={this.props.keePage} activeComponent={this.props.activeComponent} query={this.props.query}
		   	 debug={true} ></FeasPage>
		   
		   	{
		   		this.state.isShowSelectDiv&&<div className={`jdcc-select-div`} style={this.state.selectDivStyle} ></div>
		   	}
		   	</div> 
			}
		   
		   <div style={{float:'left',marginTop:'-28px' }}>当前页面：{this.props.keePage.title}[{this.props.keePage.code}]</div>
		   <div  style={{display:( this.props.controller.showReact===true||window.isReport?'none':'block'),width:'100%',height:'100%'}} divvue="vuediv">
		  
		   <div id="designContentDivVue"   
		   style={{display:( this.props.controller.showReact===true||window.isReport?'none':'block'),width:'100%',height:'100%',padding:'0'}}></div> 
		   
		   </div>
		   
		   {
		   	this.state.isShowSelectDiv&&this.props.controller.showReact!=true&&!window.isReport &&<div className={`jdcc-select-div`} style={this.state.selectDivStyle} ></div>
		   }
		   
	    </div>
		
		<div style={{height:this.state.designerContentStyle.height}}>
		</div>
		<div style={{height:'300px'}}></div>
		 
	 
		 
    </div>

	{
		!this.state.isReport&& <div  style={{'display':(this.props.controller.showCenterPage=='source'?'block':'none'),position:' absolute', top:' 10px', left:' 10px', bottom:' 10px', right:' 10px', background:' #FFFFFF', border:' 0px solid #CCCCCC',overflowY:' hidden'}} >
	        
			<pre id="code" className={`ace_editor`} style={{height:' 100%'}} >
	            <textarea className={`ace_text-input`} >
	            </textarea>
	        </pre>
			<div style={{"position":"absolute","top":"5px","right": "60px","width":"35px","height":"30px","zIndex": "80"}}> 
				 
				 <Button type="info" size="mini"   onClick={this.find} >搜索</Button>
			</div>
	</div>
	}
	
	{
		this.state.isReport?<div></div>
		:
		<div  style={{'display':(this.props.controller.showCenterPage=='data'?'block':'none'),position:' absolute', top:' 10px', left:' 10px', bottom:' 10px', right:' 10px', background:' #FFFFFF', border:' 0px solid #CCCCCC',overflowY:' hidden'}} >
		       <FsView url="M::adminDbModel/tableList&id="
		      appCode="adminDbModel"  keepAlive={true} debug={false} 
			   showVueMode={true}
			  >
		      </FsView>
			   
		</div>
		
	}
	
	
	
	 
	
	
	 


</div>
  );}
 }
